var _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _g4, _g5, _g6, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 219,
    viewBox: "0 0 350 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323.684 156.3C323.684 156.3 338.927 88.9027 297.397 50.6674C260.737 16.915 202.697 3.78316 155.384 31.6779C138.529 41.6224 126.259 60.9334 106.566 66.8982C84.4866 73.59 56.0979 75.9805 35.5939 104.644C15.0899 133.308 22.4527 170.127 49.7883 189.726C77.1238 209.326 124.963 190.192 168.073 188.767C211.183 187.341 301.069 239.467 323.684 156.3Z",
    fill: "#008080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M323.684 156.3C323.684 156.3 338.927 88.9027 297.397 50.6674C260.737 16.915 202.697 3.78316 155.384 31.6779C138.529 41.6224 126.259 60.9334 106.566 66.8982C84.4866 73.59 56.0979 75.9805 35.5939 104.644C15.0899 133.308 22.4527 170.127 49.7883 189.726C77.1238 209.326 124.963 190.192 168.073 188.767C211.183 187.341 301.069 239.467 323.684 156.3Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M334.156 201.824H340.68",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4609 201.824H330.895",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9473 201.824H24.7333",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.7199 102.565C66.5005 102.565 65.3085 102.927 64.2947 103.604C63.2808 104.282 62.4906 105.245 62.024 106.371C61.5574 107.498 61.4353 108.737 61.6732 109.933C61.911 111.129 62.4982 112.228 63.3604 113.09C64.2226 113.952 65.3212 114.539 66.5171 114.777C67.713 115.015 68.9526 114.893 70.0792 114.427C71.2057 113.96 72.1686 113.17 72.846 112.156C73.5235 111.142 73.885 109.95 73.885 108.731C73.8838 107.096 73.2339 105.528 72.0779 104.373C70.922 103.217 69.3546 102.567 67.7199 102.565ZM68.349 112.496V113.088H67.3005V112.496C66.3685 112.309 65.9025 111.601 65.9025 110.497V109.938H67.1374V110.581C67.1374 111.158 67.3937 111.368 67.7991 111.368C68.2045 111.368 68.4608 111.158 68.4608 110.581C68.4608 108.908 65.963 108.824 65.963 106.503C65.963 105.413 66.429 104.714 67.3098 104.518V103.908H68.3583V104.513C69.2623 104.7 69.7283 105.394 69.7283 106.498V106.755H68.5354V106.415C68.5354 105.837 68.3024 105.613 67.897 105.613C67.4915 105.613 67.2585 105.837 67.2585 106.415C67.2585 108.088 69.7516 108.171 69.7516 110.492C69.7283 111.601 69.253 112.296 68.349 112.496Z",
    stroke: "black",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7205 100.091C66.0115 100.09 64.3407 100.596 62.9193 101.545C61.4979 102.493 60.3898 103.842 59.7352 105.421C59.0805 107 58.9088 108.737 59.2416 110.413C59.5745 112.089 60.3969 113.629 61.605 114.838C62.8131 116.047 64.3525 116.87 66.0286 117.204C67.7046 117.537 69.442 117.367 71.021 116.713C72.5999 116.059 73.9495 114.952 74.8991 113.531C75.8486 112.11 76.3555 110.439 76.3555 108.73C76.3555 106.44 75.4459 104.243 73.8266 102.623C72.2074 101.003 70.011 100.092 67.7205 100.091ZM67.7205 115.823C66.3166 115.823 64.9442 115.407 63.777 114.627C62.6098 113.847 61.7001 112.738 61.1631 111.441C60.6261 110.144 60.4858 108.716 60.76 107.339C61.0342 105.963 61.7106 104.698 62.7037 103.706C63.6967 102.713 64.9617 102.038 66.3387 101.764C67.7158 101.491 69.1429 101.632 70.4397 102.17C71.7364 102.708 72.8445 103.618 73.6238 104.786C74.4031 105.954 74.8186 107.327 74.8177 108.73C74.8152 110.612 74.0665 112.415 72.7359 113.745C71.4054 115.074 69.6016 115.822 67.7205 115.823Z",
    stroke: "black",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.493 39.8232C190.917 39.8223 189.375 40.2889 188.064 41.1639C186.753 42.039 185.731 43.2832 185.127 44.7392C184.524 46.1952 184.365 47.7975 184.672 49.3436C184.979 50.8896 185.738 52.3099 186.852 53.4248C187.966 54.5397 189.386 55.2991 190.932 55.607C192.478 55.9148 194.08 55.7573 195.537 55.1543C196.993 54.5513 198.238 53.53 199.113 52.2194C199.989 50.9089 200.457 49.3681 200.457 47.7918C200.454 45.68 199.615 43.6553 198.122 42.1616C196.629 40.6678 194.605 39.8269 192.493 39.8232ZM193.318 52.6476V53.4118H191.966V52.6476C190.783 52.4052 190.181 51.4872 190.181 50.0613V49.339H191.743V50.1684C191.743 50.9187 192.073 51.189 192.6 51.189C193.127 51.189 193.453 50.9187 193.453 50.1684C193.453 48.0062 190.223 47.899 190.223 44.8933C190.223 43.4953 190.811 42.5633 191.966 42.3257V41.5474H193.318V42.3257C194.492 42.568 195.093 43.4674 195.093 44.8933V45.2242H193.527V44.7908C193.527 44.0405 193.229 43.7516 192.703 43.7516C192.176 43.7516 191.878 44.0405 191.878 44.7908C191.878 46.953 195.107 47.0602 195.107 50.0613C195.107 51.5059 194.492 52.4239 193.318 52.6476Z",
    stroke: "black",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.493 36.627C190.281 36.627 188.118 37.2829 186.279 38.5118C184.44 39.7407 183.006 41.4874 182.16 43.531C181.313 45.5746 181.092 47.8234 181.523 49.9928C181.955 52.1623 183.02 54.1551 184.584 55.7192C186.148 57.2833 188.141 58.3485 190.311 58.7801C192.48 59.2116 194.729 58.9901 196.773 58.1436C198.816 57.2971 200.563 55.8637 201.792 54.0245C203.021 52.1853 203.677 50.0229 203.677 47.811C203.677 44.8448 202.498 42.0001 200.401 39.9027C198.303 37.8053 195.459 36.627 192.493 36.627ZM192.493 56.9679C190.678 56.9688 188.903 56.4314 187.394 55.4238C185.884 54.4161 184.707 52.9834 184.012 51.3069C183.317 49.6303 183.135 47.7853 183.488 46.0051C183.842 44.2249 184.715 42.5896 185.998 41.3059C187.281 40.0222 188.916 39.1478 190.696 38.7934C192.476 38.439 194.321 38.6204 195.998 39.3148C197.675 40.0091 199.108 41.1852 200.117 42.6942C201.125 44.2032 201.663 45.9774 201.663 47.7923C201.661 50.2243 200.694 52.556 198.975 54.276C197.256 55.9961 194.925 56.9642 192.493 56.9679Z",
    stroke: "black",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.963 14.3799C131.708 14.3808 129.504 15.0504 127.629 16.3039C125.754 17.5574 124.293 19.3387 123.431 21.4224C122.569 23.5061 122.344 25.7987 122.784 28.0104C123.225 30.222 124.311 32.2534 125.906 33.8477C127.501 35.442 129.533 36.5275 131.745 36.9672C133.956 37.4068 136.249 37.1807 138.332 36.3175C140.416 35.4543 142.196 33.9927 143.449 32.1176C144.702 30.2425 145.37 28.038 145.37 25.7829C145.368 22.7586 144.165 19.8589 142.026 17.7208C139.887 15.5828 136.987 14.3811 133.963 14.3799ZM135.123 32.7543V33.8494H133.189V32.7543C131.493 32.4094 130.631 31.1 130.631 29.0589V28.0244H132.868V29.208C132.868 30.2845 133.334 30.6712 134.093 30.6712C134.853 30.6712 135.319 30.2845 135.319 29.208C135.319 26.1138 130.696 25.946 130.696 21.6635C130.696 19.641 131.535 18.3502 133.189 17.9867V16.8683H135.123V17.9867C136.801 18.3316 137.658 19.6177 137.658 21.6635V22.1295H135.426V21.5097C135.426 20.4379 134.993 20.0278 134.242 20.0278C133.492 20.0278 133.059 20.4379 133.059 21.5097C133.059 24.6086 137.681 24.7717 137.681 29.0589C137.681 31.1 136.801 32.4094 135.123 32.7543Z",
    stroke: "black",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.962 9.79981C130.8 9.80073 127.711 10.7389 125.083 12.4958C122.455 14.2527 120.407 16.7494 119.198 19.6701C117.989 22.5908 117.673 25.8045 118.29 28.9047C118.907 32.005 120.43 34.8526 122.666 37.0875C124.901 39.3224 127.749 40.8443 130.85 41.4606C133.95 42.077 137.164 41.7602 140.084 40.5503C143.004 39.3404 145.5 37.2917 147.257 34.6632C149.013 32.0348 149.95 28.9447 149.95 25.7836C149.95 23.6842 149.536 21.6053 148.733 19.6658C147.929 17.7262 146.752 15.964 145.267 14.4797C143.782 12.9954 142.02 11.8181 140.08 11.0152C138.14 10.2122 136.061 9.79919 133.962 9.79981ZM133.962 38.9155C131.364 38.9155 128.825 38.1453 126.666 36.7024C124.506 35.2594 122.823 33.2085 121.829 30.809C120.835 28.4094 120.575 25.769 121.082 23.2217C121.589 20.6744 122.839 18.3345 124.676 16.498C126.512 14.6614 128.852 13.4107 131.4 12.9041C133.947 12.3974 136.587 12.6574 138.987 13.6513C141.386 14.6453 143.437 16.3284 144.88 18.4879C146.323 20.6475 147.093 23.1864 147.093 25.7836C147.09 29.2653 145.705 32.6033 143.243 35.0652C140.781 37.5271 137.443 38.9118 133.962 38.9155Z",
    stroke: "black",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.894 31.4141H245.234V42.1321H249.894V31.4141Z",
    stroke: "black",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.953 25.0293H251.293V42.1315H255.953V25.0293Z",
    stroke: "black",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.01 27.2988H257.35V42.1316H262.01V27.2988Z",
    stroke: "black",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.068 23.6084H263.408V42.1319H268.068V23.6084Z",
    stroke: "black",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.492 20.6025L258.917 26.0221L265.986 20.7609L267.123 18.7804L268.33 19.4794L268.325 15.7607L265.11 17.6247L266.317 18.3191L265.273 20.1272L259.005 24.7965L253.357 19.1486L246.656 28.9765L247.425 29.5031L253.492 20.6025Z",
    stroke: "black",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7552 38.584H51.7988V47.6803H55.7552V38.584Z",
    stroke: "black",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8997 33.165H56.9434V47.6856H60.8997V33.165Z",
    stroke: "black",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0403 35.0889H62.084V47.6802H66.0403V35.0889Z",
    stroke: "black",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1849 31.958H67.2285V47.6808H71.1849V31.958Z",
    stroke: "black",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8122 29.4089L63.4116 34.0084L69.4137 29.5394L70.3783 27.8618L71.4035 28.4537L71.3989 25.2988L68.6681 26.8786L69.6933 27.4657L68.8079 29.0035L63.4862 32.9645L58.6957 28.1741L53.0059 36.5154L53.6583 36.9628L58.8122 29.4089Z",
    stroke: "black",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.338 107.375H297.223V123.736H304.338V107.375Z",
    stroke: "black",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.583 97.6318H306.467V123.742H313.583V97.6318Z",
    stroke: "black",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.833 101.094H315.717V123.737H322.833V101.094Z",
    stroke: "black",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.081 95.4648H324.965V123.737H332.081V95.4648Z",
    stroke: "black",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.829 90.8742L318.105 99.1457L328.898 91.1118L330.631 88.0921L332.477 89.1546L332.467 83.4834L327.56 86.326L329.401 87.3838L327.812 90.1472L318.24 97.2723L309.624 88.6513L299.391 103.657L300.565 104.458L309.829 90.8742Z",
    stroke: "black",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M328.099 158.272C328.099 158.272 329.497 157.196 329.599 157.117C330.531 156.185 331.808 153.855 331.151 152.55C331.035 152.334 330.876 152.145 330.682 151.995C330.489 151.845 330.266 151.738 330.028 151.68C329.79 151.622 329.543 151.614 329.302 151.658C329.061 151.702 328.832 151.796 328.63 151.935C327.754 152.489 327.381 153.715 327.297 154.693C327.209 155.844 328.099 158.268 328.099 158.272Z",
    fill: "#263238"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M339.932 155.559C338.87 154.539 336.265 155.065 335.109 155.694C335.011 155.746 333.543 156.771 333.562 156.79H333.59C333.18 156.869 332.737 156.957 332.257 157.069C331.376 157.274 330.393 157.535 329.312 157.857C328.16 158.209 327.029 158.626 325.924 159.106C324.687 159.643 323.499 160.287 322.373 161.03C322.373 161.03 322.35 161.053 322.336 161.058C322.601 160.723 323.324 159.758 323.37 159.66C324.032 158.523 324.643 155.932 323.659 154.846C323.491 154.669 323.287 154.529 323.061 154.436C322.836 154.342 322.593 154.297 322.348 154.304C322.104 154.311 321.864 154.368 321.643 154.474C321.423 154.579 321.227 154.73 321.068 154.916C320.369 155.685 320.332 156.967 320.514 157.931C320.719 159.022 322.098 160.984 322.205 161.142C321.081 161.929 320.01 162.79 318.999 163.719C318.407 164.255 317.825 164.819 317.252 165.387C317.475 165.089 317.676 164.819 317.718 164.777C318.379 163.644 318.99 161.049 318.007 159.963C317.838 159.786 317.634 159.646 317.408 159.552C317.181 159.459 316.938 159.414 316.693 159.42C316.449 159.427 316.208 159.485 315.987 159.59C315.766 159.696 315.57 159.847 315.411 160.033C314.712 160.802 314.675 162.083 314.857 163.048C315.038 164.013 316.185 165.727 316.492 166.175L315.835 166.832C314.796 167.894 313.761 168.961 312.713 169.973C312.345 170.332 311.967 170.672 311.595 171.012C311.79 170.746 311.958 170.518 311.977 170.481C312.638 169.348 313.249 166.753 312.266 165.667C312.097 165.49 311.894 165.35 311.668 165.256C311.442 165.163 311.199 165.118 310.955 165.125C310.71 165.131 310.47 165.189 310.249 165.294C310.029 165.4 309.833 165.551 309.675 165.737C308.976 166.506 308.938 167.787 309.12 168.752C309.302 169.716 310.336 171.264 310.7 171.795C310.304 172.13 309.908 172.47 309.512 172.778C309.237 172.983 308.985 173.197 308.696 173.388L307.857 173.966C307.307 174.311 306.748 174.675 306.208 174.996L305.089 175.672C305.457 175.318 306.17 174.614 306.226 174.549C306.918 173.623 307.36 172.535 307.512 171.389C307.595 171.289 307.669 171.182 307.731 171.068C307.855 170.857 307.933 170.622 307.96 170.379C307.987 170.136 307.962 169.89 307.888 169.657C307.814 169.424 307.691 169.21 307.529 169.027C307.366 168.845 307.167 168.698 306.944 168.598C305.588 168.029 303.346 169.455 302.494 170.462C302.442 170.518 301.967 171.222 301.673 171.669C301.804 171.38 301.939 171.1 302.069 170.802C302.335 170.21 302.582 169.614 302.852 168.975L303.211 168.043C303.342 167.727 303.435 167.377 303.547 167.042C303.794 166.263 304.013 165.457 304.204 164.642C304.721 164.875 306.566 165.672 307.554 165.672C308.542 165.672 309.786 165.406 310.416 164.576C310.57 164.387 310.683 164.167 310.747 163.931C310.811 163.694 310.825 163.447 310.787 163.205C310.749 162.964 310.661 162.733 310.528 162.527C310.395 162.322 310.22 162.147 310.015 162.013C308.757 161.245 306.329 162.316 305.331 163.178C305.266 163.23 304.623 163.924 304.274 164.315C304.39 163.826 304.507 163.337 304.605 162.838C304.889 161.394 305.136 159.921 305.383 158.458L305.62 157.116C305.807 157.2 307.978 158.192 309.087 158.197C310.066 158.197 311.32 157.927 311.949 157.097C312.103 156.908 312.216 156.688 312.279 156.452C312.343 156.216 312.356 155.969 312.318 155.727C312.28 155.486 312.191 155.255 312.057 155.05C311.924 154.846 311.749 154.671 311.543 154.539C310.29 153.77 307.857 154.842 306.883 155.699C306.804 155.764 305.877 156.766 305.653 157.037C305.83 156.049 306.017 155.07 306.236 154.11C306.531 152.815 306.907 151.541 307.363 150.294C307.447 150.335 309.693 151.379 310.849 151.384C311.828 151.384 313.081 151.114 313.71 150.289C313.865 150.099 313.977 149.879 314.041 149.642C314.105 149.406 314.118 149.159 314.079 148.917C314.041 148.675 313.953 148.444 313.819 148.239C313.686 148.034 313.51 147.859 313.305 147.726C312.051 146.957 309.619 148.029 308.645 148.886C308.566 148.956 307.568 150.033 307.401 150.242C307.428 150.172 307.447 150.093 307.475 150.023C307.968 148.786 308.57 147.594 309.274 146.463C309.656 145.834 310.057 145.251 310.457 144.697C310.858 144.935 312.708 146.002 313.719 146.118C314.731 146.235 315.97 146.095 316.683 145.345C316.858 145.173 316.994 144.967 317.084 144.739C317.173 144.511 317.214 144.268 317.203 144.023C317.192 143.779 317.13 143.539 317.02 143.321C316.91 143.102 316.756 142.909 316.567 142.754C315.402 141.85 312.867 142.651 311.786 143.392C311.725 143.434 311.17 143.909 310.77 144.263C310.956 144.016 311.143 143.756 311.324 143.523C312.005 142.642 312.685 141.878 313.291 141.193C313.636 140.81 313.957 140.475 314.265 140.163C314.782 140.191 316.865 140.279 317.802 139.916C318.738 139.552 319.787 138.863 320.076 137.861C320.152 137.628 320.178 137.382 320.152 137.139C320.126 136.896 320.05 136.661 319.927 136.449C319.804 136.238 319.638 136.054 319.44 135.911C319.241 135.768 319.015 135.669 318.776 135.619C317.331 135.354 315.448 137.232 314.829 138.392C314.777 138.49 314.116 140.153 314.144 140.158H314.176C313.878 140.452 313.561 140.768 313.244 141.127C312.62 141.784 311.925 142.525 311.222 143.406C310.455 144.335 309.743 145.308 309.087 146.319C308.349 147.448 307.712 148.641 307.186 149.883C307.189 149.899 307.189 149.915 307.186 149.93C307.228 149.501 307.293 148.294 307.289 148.201C307.214 146.892 306.296 144.399 304.875 144.007C304.636 143.952 304.389 143.949 304.149 143.996C303.909 144.043 303.681 144.14 303.481 144.28C303.28 144.421 303.112 144.602 302.986 144.812C302.86 145.021 302.78 145.255 302.75 145.498C302.591 146.524 303.267 147.614 303.947 148.318C304.721 149.115 306.958 149.991 307.135 150.061C306.629 151.337 306.211 152.647 305.881 153.98C305.681 154.758 305.509 155.545 305.345 156.338C305.345 155.965 305.383 155.629 305.378 155.583C305.304 154.268 304.39 151.775 302.964 151.389C302.726 151.333 302.478 151.329 302.238 151.375C301.997 151.422 301.769 151.519 301.569 151.66C301.368 151.8 301.2 151.982 301.074 152.192C300.948 152.402 300.868 152.637 300.839 152.88C300.681 153.905 301.357 154.995 302.042 155.699C302.727 156.403 304.623 157.2 305.126 157.4L304.945 158.332C304.665 159.795 304.386 161.254 304.073 162.675C303.961 163.178 303.836 163.668 303.71 164.157C303.71 163.826 303.742 163.551 303.738 163.505C303.663 162.195 302.75 159.702 301.324 159.311C301.085 159.256 300.838 159.252 300.598 159.299C300.358 159.346 300.13 159.443 299.93 159.584C299.729 159.724 299.561 159.905 299.435 160.115C299.309 160.325 299.229 160.559 299.199 160.802C299.04 161.827 299.716 162.917 300.401 163.621C301.086 164.325 302.801 165.047 303.398 165.289C303.253 165.788 303.109 166.287 302.932 166.762C302.81 167.088 302.722 167.405 302.587 167.722C302.452 168.039 302.33 168.356 302.205 168.654C301.939 169.241 301.669 169.856 301.398 170.425C301.212 170.821 301.026 171.198 300.839 171.576C300.956 171.077 301.165 170.098 301.17 170.015C301.296 168.705 300.769 166.1 299.418 165.518C299.19 165.427 298.946 165.385 298.701 165.395C298.456 165.404 298.216 165.466 297.996 165.574C297.777 165.683 297.582 165.836 297.426 166.025C297.269 166.213 297.154 166.433 297.088 166.669C296.776 167.661 297.279 168.84 297.848 169.642C298.472 170.523 300.462 171.692 300.713 171.837C300.401 172.461 300.098 173.067 299.781 173.631C299.39 174.376 299.017 175.066 298.663 175.7C298.821 175.933 299.022 176.222 299.255 176.553C299.66 175.798 300.098 174.954 300.555 174.027C300.872 173.393 301.198 172.713 301.524 172.004C302.238 172.203 302.963 172.358 303.696 172.47C303.798 173.575 304.744 175.513 304.87 175.76C304.264 176.115 303.677 176.45 303.113 176.758C302.149 177.289 301.249 177.76 300.452 178.156L301.035 178.906C301.799 178.496 302.638 178.03 303.542 177.508C304.157 177.154 304.805 176.762 305.467 176.352C305.653 176.567 307.168 178.319 308.151 178.771C309.041 179.186 310.29 179.465 311.208 178.976C311.428 178.869 311.623 178.717 311.78 178.529C311.937 178.342 312.053 178.123 312.12 177.888C312.186 177.652 312.203 177.406 312.168 177.163C312.133 176.921 312.047 176.689 311.916 176.483C311.096 175.257 308.44 175.215 307.177 175.551C307.102 175.574 306.319 175.896 305.825 176.105C306.096 175.937 306.361 175.779 306.636 175.602C307.182 175.257 307.717 174.898 308.295 174.512L309.125 173.915C309.404 173.724 309.675 173.486 309.954 173.267C310.588 172.755 311.208 172.2 311.818 171.627C312.121 172.093 313.216 173.789 314.046 174.334C314.875 174.88 316.054 175.341 317.037 175.001C317.271 174.927 317.486 174.805 317.669 174.643C317.853 174.481 318 174.282 318.101 174.059C318.203 173.836 318.256 173.595 318.259 173.35C318.261 173.105 318.211 172.863 318.114 172.638C317.489 171.305 314.852 170.863 313.566 171.026C313.486 171.026 312.564 171.264 312.061 171.394C312.424 171.049 312.792 170.704 313.151 170.341C314.185 169.297 315.197 168.207 316.217 167.121C316.525 166.79 316.842 166.459 317.149 166.133C317.256 166.305 318.524 168.332 319.442 168.929C320.262 169.474 321.455 169.94 322.434 169.595C322.667 169.522 322.882 169.401 323.065 169.239C323.249 169.077 323.396 168.878 323.497 168.656C323.599 168.434 323.652 168.192 323.655 167.948C323.657 167.704 323.608 167.461 323.51 167.237C322.886 165.9 320.248 165.457 318.967 165.62C318.869 165.62 317.541 165.96 317.205 166.058C317.895 165.336 318.603 164.618 319.302 163.943C320.261 163.023 321.279 162.166 322.35 161.38C322.401 161.459 323.711 163.584 324.652 164.208C325.472 164.753 326.665 165.219 327.648 164.875C327.867 164.798 328.068 164.679 328.24 164.524C328.412 164.369 328.551 164.181 328.649 163.971C328.748 163.762 328.803 163.535 328.813 163.303C328.823 163.072 328.787 162.841 328.706 162.624C328.082 161.286 325.444 160.844 324.158 161.007C324.055 161.007 322.629 161.37 322.373 161.473L322.56 161.328C323.654 160.569 324.815 159.907 326.027 159.353C326.688 159.04 327.345 158.775 327.984 158.532C328.189 158.952 329.139 160.862 329.927 161.524C330.715 162.186 331.814 162.745 332.83 162.512C333.069 162.465 333.295 162.368 333.495 162.227C333.694 162.087 333.861 161.907 333.987 161.698C334.112 161.489 334.192 161.256 334.221 161.014C334.251 160.772 334.229 160.527 334.158 160.294C333.692 158.896 331.129 158.169 329.815 158.192C329.745 158.192 329.018 158.285 328.492 158.36C328.785 158.257 329.084 158.141 329.363 158.048C330.416 157.689 331.404 157.423 332.28 157.2C332.779 157.074 333.212 156.971 333.678 156.878C334.093 157.186 335.785 158.407 336.763 158.626C337.742 158.845 339.005 158.84 339.797 158.16C339.989 158.006 340.146 157.813 340.258 157.594C340.37 157.375 340.435 157.135 340.448 156.89C340.461 156.644 340.421 156.399 340.332 156.169C340.243 155.94 340.107 155.732 339.932 155.559Z",
    fill: "#263238"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M307.738 141.869C308.293 142.875 310.376 144.409 310.381 144.409C310.385 144.409 310.972 142.731 310.996 142.619C311.271 141.333 311.042 138.686 309.77 137.959C309.555 137.843 309.317 137.773 309.073 137.755C308.829 137.737 308.584 137.77 308.354 137.852C308.123 137.935 307.913 138.065 307.736 138.235C307.56 138.404 307.421 138.609 307.328 138.835C306.904 139.791 307.268 141.007 307.738 141.869Z",
    fill: "#263238"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3814 44.7874C83.4233 44.7874 82.2956 41.9914 82.2024 41.8236C81.1399 39.885 77.9525 36.7535 75.5153 37.2195C75.1134 37.3075 74.7345 37.4791 74.4033 37.7231C74.0721 37.9672 73.796 38.2782 73.5929 38.636C73.3898 38.9938 73.2644 39.3904 73.2246 39.7998C73.1849 40.2093 73.2318 40.6226 73.3624 41.0128C73.8656 42.6904 75.6924 43.86 77.2208 44.4379C79.0382 45.1182 83.3767 44.7874 83.3814 44.7874Z",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.418 24.3952C82.2837 25.6487 81.9435 30.1037 82.4235 32.2613C82.4654 32.4477 83.4487 35.2949 83.486 35.267L83.5279 35.2344C83.472 35.938 83.4161 36.6929 83.3695 37.5178C83.3042 39.0416 83.239 40.7798 83.2949 42.6438C83.3305 44.6705 83.4861 46.6934 83.7609 48.7018C84.0567 50.9533 84.5526 53.1741 85.2428 55.3376C85.2549 55.3613 85.2643 55.3863 85.2708 55.4122C84.8514 54.8203 83.6165 53.208 83.5046 53.0822C81.9715 51.4884 78.0664 49.3169 75.8389 50.4027C75.4747 50.5944 75.1549 50.8606 74.9002 51.1839C74.6455 51.5073 74.4617 51.8806 74.3606 52.2796C74.2595 52.6786 74.2435 53.0944 74.3135 53.5C74.3836 53.9056 74.5381 54.2919 74.7671 54.6339C75.6991 56.1205 77.7449 56.7682 79.3945 56.9173C81.2585 57.0851 85.0657 55.7523 85.3686 55.6452C86.1247 57.8295 87.0261 59.9607 88.0668 62.0247C88.6679 63.2316 89.311 64.4246 89.968 65.6176C89.5859 65.1189 89.2411 64.6856 89.1852 64.6157C87.652 63.0266 83.7469 60.8504 81.5241 61.9408C81.1597 62.1317 80.8395 62.3971 80.5843 62.7198C80.3292 63.0426 80.1449 63.4154 80.0434 63.8141C79.9418 64.2128 79.9253 64.6283 79.995 65.0338C80.0647 65.4393 80.2189 65.8255 80.4477 66.1674C81.3797 67.654 83.4301 68.3017 85.075 68.4508C86.72 68.6 90.0193 67.5188 90.8814 67.2392C91.1424 67.7052 91.394 68.1712 91.6503 68.6C92.8945 70.7762 94.1434 72.9384 95.3037 75.1007C95.7138 75.8602 96.0913 76.6245 96.4687 77.3887C96.1286 76.946 95.8396 76.5779 95.7884 76.5266C94.2552 74.9329 90.3502 72.7567 88.1227 73.8471C87.7585 74.0389 87.4386 74.305 87.184 74.6284C86.9293 74.9518 86.7454 75.325 86.6444 75.724C86.5433 76.123 86.5273 76.5388 86.5973 76.9445C86.6673 77.3501 86.8219 77.7364 87.0509 78.0784C87.9829 79.5603 90.0286 80.2127 91.6736 80.3618C93.3186 80.5109 96.301 79.5463 97.3308 79.1968C97.6943 79.9937 98.0578 80.7859 98.3747 81.5734C98.5797 82.114 98.8127 82.6219 98.9898 83.1764C99.1669 83.731 99.3533 84.2622 99.535 84.7981C99.8472 85.842 100.173 86.9138 100.467 87.939C100.663 88.6519 100.84 89.337 101.017 90.022C100.621 89.2577 99.81 87.7805 99.7261 87.6687C98.5457 86.1204 96.9877 84.9009 95.2012 84.1271C95.0767 83.95 94.9363 83.7847 94.7818 83.6331C94.4972 83.336 94.1533 83.102 93.7724 82.9463C93.3915 82.7907 92.9821 82.7168 92.5709 82.7296C92.1596 82.7423 91.7556 82.8414 91.385 83.0203C91.0145 83.1992 90.6858 83.4541 90.4201 83.7683C88.8776 85.7068 90.1591 89.9894 91.3847 91.8301C91.4592 91.9372 92.3726 93.0323 92.9644 93.6941L91.7435 92.6549C90.9094 91.9559 90.0566 91.2802 89.1432 90.5532C88.6772 90.213 88.2112 89.8729 87.7452 89.5327C87.2792 89.1925 86.7713 88.8663 86.282 88.5308C85.131 87.7712 83.9287 87.0629 82.6984 86.3685C83.3089 85.6416 85.4478 83.0133 85.9045 81.4196C86.3612 79.8259 86.4917 77.6916 85.4385 76.2936C85.2022 75.957 84.8978 75.6739 84.5449 75.4627C84.192 75.2514 83.7986 75.1168 83.3903 75.0676C82.982 75.0184 82.5679 75.0556 82.1749 75.1769C81.7819 75.2983 81.4189 75.5009 81.1094 75.7717C79.2873 77.454 79.9118 81.881 80.8438 83.8848C80.8997 84.0106 81.7292 85.376 82.1998 86.1169C81.4589 85.7068 80.7226 85.2967 79.9584 84.9053C77.7542 83.7822 75.4848 82.7104 73.2293 81.6433C72.535 81.3124 71.8313 80.9769 71.1649 80.6414C71.384 80.3851 73.9889 77.3188 74.5015 75.5154C74.9675 73.9263 75.0933 71.7874 74.0355 70.3894C73.7991 70.0523 73.4945 69.7687 73.1414 69.557C72.7883 69.3453 72.3946 69.2103 71.9859 69.1606C71.5772 69.111 71.1627 69.1478 70.7691 69.2688C70.3756 69.3898 70.0119 69.5922 69.7017 69.8628C67.8843 71.5451 68.5041 75.9721 69.4361 77.9805C69.506 78.1297 70.7036 80.0915 71.0345 80.5762C69.52 79.8399 68.0194 79.0896 66.5702 78.2928C64.6076 77.225 62.7163 76.0311 60.9083 74.7185C61.0108 74.5974 63.7462 71.4099 64.2681 69.5925C64.7341 68.0035 64.8553 65.8645 63.8021 64.4665C63.5658 64.1295 63.2611 63.8459 62.908 63.6342C62.5549 63.4225 62.1612 63.2874 61.7526 63.2378C61.3439 63.1881 60.9293 63.2249 60.5358 63.3459C60.1422 63.4669 59.7786 63.6693 59.4683 63.94C57.6509 65.6222 58.2707 70.0492 59.2027 72.053C59.2773 72.2115 60.5634 74.3224 60.8244 74.6859C60.7219 74.6114 60.6054 74.5415 60.5029 74.4669C58.7349 73.0899 57.0927 71.5585 55.5959 69.8908C54.7524 68.9867 53.9928 68.0734 53.2659 67.1693C53.8344 66.6288 56.4114 64.1217 57.0638 62.5093C57.7162 60.897 58.061 58.8559 57.171 57.3507C56.9729 56.9899 56.7011 56.6747 56.3733 56.4257C56.0454 56.1767 55.6689 55.9994 55.2681 55.9054C54.8674 55.8113 54.4513 55.8026 54.0469 55.8798C53.6426 55.957 53.259 56.1184 52.921 56.3535C50.9312 57.826 51.057 62.295 51.7654 64.392C51.8026 64.5038 52.3246 65.6222 52.6974 66.4284C52.3805 66.0183 52.045 65.5943 51.7654 65.1935C50.6516 63.6883 49.7243 62.2391 48.9134 60.9482C48.4474 60.212 48.0607 59.5502 47.6972 58.9025C47.9814 58.0777 49.0952 54.7458 48.9228 53.0589C48.7503 51.3719 48.1399 49.3868 46.6347 48.4548C46.2931 48.2326 45.9089 48.0841 45.5067 48.0185C45.1045 47.9529 44.6931 47.9718 44.2986 48.0739C43.9041 48.1761 43.5351 48.3592 43.2153 48.6117C42.8954 48.8642 42.6316 49.1805 42.4407 49.5406C41.3503 51.7634 43.5265 55.6685 45.1202 57.2063C45.26 57.3367 47.6506 59.1635 47.6646 59.1215V59.0749C48.0001 59.69 48.3729 60.3518 48.7923 61.0647C49.5752 62.3742 50.4745 63.8607 51.5603 65.3846C52.7083 67.0529 53.9531 68.6524 55.2883 70.175C56.7783 71.8887 58.4173 73.4668 60.186 74.891L60.2559 74.9376C59.5755 74.6766 57.6556 74.0056 57.5018 73.9823C55.3442 73.5163 50.8893 73.8425 49.6311 75.9767C49.4332 76.3375 49.3134 76.7359 49.2795 77.1459C49.2455 77.556 49.2981 77.9686 49.4339 78.3571C49.5697 78.7455 49.7856 79.101 50.0676 79.4006C50.3496 79.7002 50.6915 79.9372 51.071 80.0962C52.6601 80.8278 54.7338 80.2313 56.197 79.4484C57.8373 78.5677 60.2838 75.3523 60.4796 75.096C62.3168 76.4985 64.2456 77.7766 66.2533 78.9219C67.4183 79.5976 68.6113 80.2406 69.8182 80.8697C69.2217 80.6647 68.6905 80.4876 68.6159 80.469C66.4537 80.003 61.9987 80.3245 60.7452 82.4635C60.5465 82.8238 60.4258 83.2219 60.3912 83.632C60.3565 84.042 60.4086 84.4547 60.5439 84.8433C60.6793 85.2319 60.895 85.5876 61.177 85.8874C61.459 86.1871 61.8009 86.4241 62.1805 86.5829C63.7742 87.3145 65.8432 86.718 67.3065 85.9352C68.7697 85.1523 70.9226 82.4402 71.4772 81.7179C71.9432 81.9555 72.4092 82.1839 72.8752 82.4308C75.112 83.5586 77.3488 84.677 79.511 85.8373C80.2706 86.2474 81.0069 86.6761 81.7431 87.1048C81.2166 86.9231 80.7692 86.774 80.6993 86.76C78.5417 86.294 74.0821 86.6155 72.8286 88.7545C72.63 89.1151 72.5096 89.5135 72.4752 89.9238C72.4409 90.334 72.4933 90.7469 72.6292 91.1355C72.765 91.5242 72.9812 91.8798 73.2637 92.1794C73.5461 92.4789 73.8885 92.7155 74.2685 92.8739C75.8576 93.6009 77.9313 93.009 79.3945 92.2262C80.8577 91.4433 82.801 88.9921 83.4673 88.1393C84.2083 88.6053 84.9539 89.0713 85.6482 89.5373C86.1142 89.8775 86.5802 90.1711 87.0462 90.5346L88.3976 91.5877C89.2318 92.2867 90.0985 92.9857 90.8954 93.7034C91.4546 94.1694 91.9765 94.6354 92.5031 95.134C91.7528 94.7193 90.257 93.9317 90.1265 93.8805C88.0668 93.0789 83.6025 92.7388 82.046 94.6633C81.7948 94.9892 81.6151 95.3644 81.5187 95.7645C81.4222 96.1645 81.4113 96.5804 81.4865 96.985C81.5616 97.3896 81.7213 97.7738 81.9551 98.1124C82.1888 98.4511 82.4913 98.7367 82.8429 98.9505C84.3061 99.9152 86.4404 99.6402 88.0015 99.0903C89.7117 98.4799 92.5171 95.7911 92.8666 95.4555C93.738 96.2431 94.5768 97.0166 95.3597 97.7576C96.3849 98.7315 97.3308 99.6542 98.1929 100.516C98.6589 100.367 99.2042 100.176 99.8472 99.9478C98.8081 98.9459 97.6477 97.8508 96.3569 96.6858C95.4762 95.8843 94.4929 95.0455 93.5236 94.1927C94.1807 93.1293 94.7736 92.0276 95.2991 90.8934C97.1351 91.2382 100.7 90.5952 101.161 90.5066C101.455 91.6437 101.73 92.7527 101.968 93.8059C102.392 95.614 102.741 97.2776 103.035 98.7595C103.501 98.5731 104.009 98.3727 104.517 98.163C104.2 96.765 103.832 95.1666 103.398 93.4564C103.105 92.3007 102.769 91.0705 102.41 89.8123C102.844 89.6119 106.367 87.9483 107.536 86.5829C108.617 85.3294 109.643 83.4327 109.27 81.7225C109.197 81.3161 109.038 80.9296 108.805 80.5886C108.573 80.2476 108.27 79.9596 107.918 79.7435C107.566 79.5275 107.173 79.3883 106.763 79.335C106.353 79.2818 105.937 79.3157 105.542 79.4345C103.184 80.1987 101.898 84.4766 101.902 86.6901C101.902 86.8206 102.065 88.2372 102.182 89.1273C102.033 88.6147 101.893 88.116 101.716 87.5895C101.408 86.5456 101.073 85.5111 100.709 84.3974L100.127 82.7897C99.9451 82.2491 99.6841 81.6992 99.4605 81.1493C98.9152 79.8818 98.3048 78.6236 97.6617 77.3701C98.5937 77.0951 101.804 76.0839 103.067 75.0028C104.33 73.9217 105.621 72.2068 105.514 70.464C105.503 70.0526 105.406 69.6481 105.228 69.2769C105.051 68.9057 104.797 68.576 104.484 68.3095C104.17 68.043 103.804 67.8457 103.409 67.7303C103.014 67.6149 102.599 67.5842 102.191 67.64C99.7447 68.0361 97.8201 72.0717 97.4893 74.2619C97.4893 74.397 97.4101 75.9907 97.3961 76.8715C97 76.1212 96.6132 75.3663 96.1891 74.6207C94.9729 72.4678 93.6727 70.3242 92.3819 68.1806C91.9858 67.5235 91.6037 66.8664 91.2123 66.2047C91.5385 66.1162 95.4063 64.9931 96.8043 63.7862C98.0578 62.7097 99.3579 60.9902 99.2508 59.2473C99.2401 58.8358 99.1428 58.4312 98.9653 58.0598C98.7879 57.6883 98.5341 57.3584 98.2207 57.0916C97.9072 56.8247 97.5411 56.6269 97.1461 56.511C96.7511 56.395 96.3361 56.3636 95.9282 56.4187C93.4817 56.8195 91.5571 60.8504 91.2309 63.0406C91.2029 63.2037 91.1191 65.5011 91.1284 66.0882C90.2756 64.639 89.4368 63.185 88.6679 61.7171C87.6159 59.7454 86.6959 57.7061 85.9138 55.6125C86.0676 55.5706 90.1078 54.4196 91.5524 53.18C92.806 52.1082 94.1061 50.384 93.9989 48.6412C93.9882 48.2297 93.891 47.825 93.7135 47.4536C93.536 47.0822 93.2823 46.7523 92.9689 46.4854C92.6554 46.2186 92.2893 46.0207 91.8943 45.9048C91.4993 45.7889 91.0843 45.7574 90.6764 45.8126C88.2299 46.2133 86.3099 50.2489 85.9791 52.4344C85.9511 52.6068 85.8626 55.0813 85.8812 55.5287C85.8346 55.4075 85.774 55.2863 85.7321 55.1652C85.0057 53.0419 84.4677 50.8588 84.1244 48.6412C83.9194 47.4203 83.7935 46.2413 83.6957 45.0903C84.4692 44.9551 88.0015 44.2887 89.4275 43.3195C90.8534 42.3502 92.2747 40.8217 92.3586 39.0742C92.3927 38.6642 92.3402 38.2517 92.2044 37.8634C92.0686 37.4751 91.8526 37.1197 91.5704 36.8204C91.2882 36.521 90.9462 36.2845 90.5665 36.126C90.1869 35.9676 89.7782 35.8908 89.3669 35.9007C86.8924 36.0266 84.5345 39.8245 83.9706 41.9587C83.938 42.0752 83.7563 43.2915 83.6351 44.1816C83.5978 43.6643 83.5512 43.1284 83.5279 42.6298C83.4301 40.7658 83.4534 39.0369 83.4906 37.5038C83.5186 36.6417 83.5605 35.8588 83.6025 35.1272C84.2922 34.5959 87.0462 32.4197 87.8477 30.9332C88.6493 29.4466 89.2457 27.4056 88.4955 25.8072C88.3337 25.4352 88.0966 25.1009 87.799 24.8254C87.5014 24.5498 87.1499 24.339 86.7666 24.2063C86.3834 24.0736 85.9768 24.0218 85.5725 24.0544C85.1682 24.0869 84.7751 24.2029 84.418 24.3952Z",
    fill: "#263238"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4827 70.2264C49.37 69.793 52.8091 67.1228 52.8091 67.1182C52.8091 67.1135 50.3626 65.3893 50.1948 65.3008C48.2376 64.2662 43.8526 63.4368 42.0771 65.147C41.7897 65.4418 41.5677 65.794 41.4257 66.1805C41.2836 66.567 41.2248 66.9791 41.2529 67.3899C41.2811 67.8007 41.3956 68.2009 41.589 68.5644C41.7824 68.9279 42.0504 69.2466 42.3753 69.4994C43.7174 70.6225 45.8703 70.5992 47.4827 70.2264Z",
    fill: "#263238"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4959 52.9795H298.232C299.012 52.9795 299.784 53.1331 300.504 53.4314C301.224 53.7298 301.879 54.1671 302.43 54.7183C302.981 55.2696 303.419 55.9241 303.717 56.6444C304.015 57.3647 304.169 58.1367 304.169 58.9163V191.619H90.5684V58.9117C90.5696 57.3395 91.1943 55.8321 92.3056 54.72C93.4168 53.6079 94.9238 52.982 96.4959 52.9795Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M271.256 184.946H124.461V192.179H271.256V184.946Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M271.256 188.428H124.461V192.179H271.256V188.428Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2949 196.466C73.2949 196.466 75.7088 199.411 82.9411 201.825H312.777C312.777 201.825 318.136 200.483 320.545 196.731L73.2949 196.466Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M319.263 191.186H74.6034C73.61 191.186 72.8047 191.991 72.8047 192.984V195.021C72.8047 196.014 73.61 196.819 74.6034 196.819H319.263C320.256 196.819 321.062 196.014 321.062 195.021V192.984C321.062 191.991 320.256 191.186 319.263 191.186Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M199.197 57.1687C199.197 56.8 199.087 56.4396 198.883 56.1331C198.678 55.8266 198.387 55.5877 198.046 55.4466C197.705 55.3055 197.331 55.2686 196.969 55.3405C196.608 55.4124 196.275 55.59 196.015 55.8506C195.754 56.1113 195.576 56.4435 195.505 56.805C195.433 57.1666 195.47 57.5414 195.611 57.882C195.752 58.2226 195.991 58.5137 196.297 58.7185C196.604 58.9234 196.964 59.0327 197.333 59.0327C197.827 59.0327 198.301 58.8363 198.651 58.4867C199 58.1372 199.197 57.6631 199.197 57.1687Z",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5808 91.993C92.4387 91.993 92.3024 91.9365 92.2019 91.836C92.1014 91.7355 92.0449 91.5992 92.0449 91.4571V75.9207C92.0461 75.7789 92.103 75.6433 92.2032 75.5431C92.3035 75.4428 92.4391 75.386 92.5808 75.3848C92.723 75.3848 92.8593 75.4412 92.9598 75.5417C93.0603 75.6422 93.1167 75.7785 93.1167 75.9207V91.4571C93.1173 91.5277 93.1039 91.5976 93.0772 91.6629C93.0505 91.7282 93.011 91.7875 92.9612 91.8374C92.9113 91.8873 92.8519 91.9268 92.7866 91.9535C92.7213 91.9802 92.6514 91.9936 92.5808 91.993Z",
    fill: "#263238",
    stroke: "white",
    strokeWidth: 0.322327,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M295.502 63.8096H99.2363V174.722H295.502V63.8096Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M295.503 63.8096H131.854V70.3709H295.503V63.8096Z",
    fill: "#008080",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7699 156.985L46.9712 168.169L45.7689 193.166C45.7689 193.166 48.3692 197.565 48.7699 198.166C49.1707 198.767 52.3675 200.365 51.9714 201.162C51.5753 201.959 45.9693 201.162 45.9693 201.162C45.3742 200.072 44.5566 199.12 43.5694 198.366C41.971 197.164 41.5702 197.863 41.5702 196.665C41.5702 195.468 41.7706 193.464 41.7706 193.464C41.7706 193.464 40.1722 169.372 40.1722 165.97C40.1722 162.568 39.7715 158.174 39.7715 158.174L48.7699 156.985Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2337 157.717L40.7677 168.901L38.7732 192.695L40.3064 198.524C40.3064 198.524 41.2384 200.388 41.5366 200.826C41.8348 201.264 41.3828 201.758 40.7677 201.758H38.9829C38.6005 201.76 38.2239 201.664 37.8883 201.481C37.5526 201.298 37.2687 201.032 37.063 200.71C36.6251 199.989 36.1195 199.312 35.5532 198.688C34.6212 197.756 35.0872 195.16 35.0872 194.391V192.867C35.0872 192.867 32.7851 175.061 32.9389 172.452C33.0927 169.842 33.2465 167.848 33.2465 167.848L32.3145 157.717H41.2337Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0892 142.412L29.1451 142.198L28.9727 140.991L30.1703 136.391L30.7341 136.517L31.4098 134.089L41.8622 134.029C43.4512 134.131 45.0451 134.131 46.6341 134.029C47.5341 133.916 48.4393 133.851 49.3462 133.833L49.4161 134.103L49.966 133.791C49.966 133.791 51.1682 141.988 50.7675 148.587C50.3667 155.185 49.3695 165.199 49.3695 165.199H31.5729L31.1815 156.276H31.1069C31.051 155.688 30.9858 155.097 30.9252 154.514L29.8581 147.17C29.4759 144.882 29.0892 142.412 29.0892 142.412Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9247 105.889C49.9247 105.889 53.9323 126.015 53.2193 127.087C52.5063 128.159 50.9545 128.993 50.0039 127.921C49.0533 126.849 48.2145 111.01 47.8603 109.817C47.5061 108.624 48.303 105.055 49.9247 105.889Z",
    fill: "#008080",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2628 121.014C52.2628 121.014 55.2405 122.44 55.4782 123.158C55.7158 123.876 55.124 126.611 54.0522 127.562C52.9804 128.512 51.3121 129.468 50.7157 127.921C50.1192 126.373 50.478 120.772 52.2628 121.014Z",
    fill: "#008080",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8058 122.79C53.8058 122.79 53.3398 123.634 53.3398 125.656C53.3398 127.679 53.8058 127.921 54.0575 127.562C54.3091 127.203 54.7565 124.985 54.7565 124.985C54.7565 124.985 54.9941 122.66 53.8058 122.79Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8051 122.79C53.8051 122.79 57.4958 123.023 58.1249 123.34C59.4797 124.112 60.7442 125.032 61.8949 126.085C62.9154 127.105 62.8269 127.734 62.2863 127.734H60.5575C59.7746 127.734 57.7335 126.714 57.4958 126.635C57.2582 126.555 56.5638 126.243 55.9254 126.005C55.4548 125.769 55.0511 125.418 54.7511 124.985L53.4929 124.281C53.4929 124.281 53.4137 123.261 53.8051 122.79Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7933 125.301C57.2431 125.892 57.7696 126.42 58.359 126.871C59.291 127.575 59.1466 127.892 58.5967 127.803C58.0468 127.715 56.7327 126.545 56.7327 126.545C56.7327 126.545 55.2415 126.233 54.7708 125.762C54.4565 125.422 54.2154 125.021 54.0625 124.583L54.1417 124.117",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7933 125.301C57.2431 125.892 57.7696 126.42 58.359 126.871C59.291 127.575 59.1466 127.892 58.5967 127.803C58.0468 127.715 56.7327 126.545 56.7327 126.545C56.7327 126.545 55.2415 126.233 54.7708 125.762C54.4565 125.422 54.2154 125.021 54.0625 124.583L54.1417 124.117",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5586 127.734C60.5586 127.734 58.7552 125.693 58.0469 124.984",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4246 127.576C61.4246 127.576 60.1664 125.381 58.9082 124.515",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2861 127.734C61.7123 126.715 61.0561 125.744 60.3242 124.831",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0547 102.51C43.0547 102.51 49.9235 105.436 49.9235 105.888C49.9235 106.34 50.958 116.676 50.958 118.289C50.958 119.901 51.424 131.448 51.3448 132.995C51.2656 134.543 52.1417 141.849 51.946 141.957C51.7502 142.064 51.8108 143.299 50.3289 143.038C48.8471 142.777 49.0847 134.221 49.0847 134.221L47.9244 126.868L47.8591 122.082C47.8591 122.082 47.8591 116.988 47.3465 114.16C46.8388 111.792 46.1038 109.48 45.1517 107.254C45.0212 107.063 43.0547 102.51 43.0547 102.51Z",
    fill: "#008080",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2803 100.995C37.2803 100.995 33.8319 102.281 31.8841 103.134C29.0881 104.35 27.0656 104.896 26.9351 105.734C26.8047 106.573 29.568 128.415 29.568 128.415L25.7422 143.415C25.7422 143.415 31.8654 145.745 36.1852 145.559C38.4696 145.509 40.7391 145.177 42.9422 144.571L43.1519 134.417C43.1519 134.417 43.9581 128.312 42.3178 119.174C40.9198 111.471 38.4407 101.512 38.4407 101.512L37.2803 100.995Z",
    fill: "#008080",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6049 103.707C44.6131 104.766 45.4994 105.936 46.2471 107.193C46.7855 108.184 47.2391 109.219 47.6032 110.287L46.6339 110.674L48.7635 113.32C48.9458 114.887 48.9019 116.473 48.6331 118.027C48.1671 120.418 47.6684 124.285 47.6684 124.285C47.6684 124.285 43.5397 124.351 42.3141 123.577C41.0885 122.804 36.764 114.285 36.573 113.577C36.3819 112.868 38.3112 109.965 38.3112 109.965L36.9831 109.653L34.4434 109.061C34.4434 109.061 35.2822 103.576 35.7948 102.16C36.3074 100.743 36.0557 100.547 37.2161 100.095C38.3764 99.6433 43.1529 103.511 43.1529 103.511L43.6049 103.707Z",
    fill: "#008080",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7975 95.2541C39.6185 96.5768 39.2934 97.8755 38.8282 99.1266C38.5997 99.6988 38.3415 100.259 38.0547 100.804C39.382 105.152 40.4802 109.566 41.3447 114.029C42.505 120.418 43.2786 126.672 43.2786 129.836C43.2786 133 43.1527 134.417 43.1527 134.417C43.1527 134.417 43.861 134.804 45.7297 134.673C46.875 134.59 48.0037 134.352 49.0849 133.965C49.0849 133.965 47.4726 120.027 47.4073 116.676C47.3421 113.326 43.9915 104.374 43.9915 104.374L44.5694 102.51C44.5694 102.51 42.6355 100.18 42.1834 98.4462C41.7314 96.7127 40.7016 95.1283 39.7975 95.2541Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M42.195 98.4502C42.661 100.188 44.5716 102.481 44.5716 102.481L43.9938 104.345L44.2221 104.979C42.1158 102.919 40.8203 99.2564 40.8203 99.2564L42.195 98.4502Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4141 109.584C42.2014 109.941 44.0349 110.005 45.843 109.775C46.6352 112.296 47.3808 115.092 47.4087 116.677C47.474 120.027 49.0863 133.965 49.0863 133.965C48.0051 134.352 46.8764 134.59 45.7311 134.673C43.8671 134.804 43.1541 134.417 43.1541 134.417C43.1541 134.417 43.28 132.996 43.28 129.836C43.28 126.677 42.5064 120.418 41.3461 114.03C41.0758 112.543 40.7542 111.029 40.4141 109.584Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2773 120.144L43.8672 120.619",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9618 117.039L44.5898 119.779",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8985 119.746L44.0625 121.484",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4298 92.7748C51.736 92.8621 52.0633 92.8374 52.3529 92.705C52.6425 92.5726 52.8753 92.3412 53.0095 92.0525C53.5035 91.0086 52.4923 90.8409 52.5435 89.8436C52.5948 88.8464 53.6107 87.9796 53.0701 87.0476C52.5296 86.1156 48.8761 83.8089 47.096 82.7837C45.3159 81.7585 42.7436 82.3177 40.6139 82.9888C38.4843 83.6598 36.8487 84.3868 36.2988 85.9339C35.7489 87.481 35.7862 88.8557 35.1431 90.0254C34.5 91.195 33.2791 91.3302 33.9408 92.6909C34.6025 94.0516 35.8048 93.9258 35.5019 94.8951C35.199 95.8644 34.7237 96.9082 35.446 97.4348C36.1683 97.9614 37.4079 97.2251 38.009 97.7097C38.6101 98.1944 39.0342 98.5392 39.5282 98.4833C40.0221 98.4274 40.339 97.3509 41.5087 95.9016C42.6783 94.4524 43.9738 93.2082 45.5862 92.8167C47.1985 92.4253 48.6711 91.7682 49.631 91.9919C50.2692 92.1534 50.8767 92.4178 51.4298 92.7748Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2454 92.9336C38.0649 93.0548 37.8569 93.1289 37.6404 93.1492C37.424 93.1696 37.2058 93.1355 37.0059 93.0501",
    stroke: "#808080",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7027 87.6768C50.7027 87.6768 50.7027 89.3311 48.1071 89.3311C45.5115 89.3311 42.38 89.154 41.1171 90.2165C40.3995 90.8316 39.584 91.8941 38.7871 92.5465",
    stroke: "#808080",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5171 86.9921C43.0382 86.9731 42.5603 87.0498 42.1114 87.2179C41.6625 87.3859 41.2516 87.6419 40.9029 87.9707C39.2486 89.5691 38.1861 91.4564 36.9465 91.517C36.3704 91.586 35.7861 91.5255 35.2363 91.3399",
    stroke: "#808080",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8579 87.2055C44.6479 87.1376 44.4329 87.0861 44.2148 87.0518",
    stroke: "#808080",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M52.046 89.7881C52.046 89.7881 52.5913 92.2625 51.5241 94.1405C50.457 96.0185 50.3265 95.8135 50.0236 97.6122C49.7207 99.411 48.9937 100.315 47.5305 101.573C46.0673 102.831 45.2005 102.873 44.3058 102.361C43.4111 101.848 40.4613 99.4157 40.3075 98.493C40.1537 97.5703 39.9254 96.4938 39.9254 96.4938C39.6242 96.2438 39.3536 95.9591 39.1192 95.6457C39.0603 95.4511 39.0198 95.2514 38.998 95.0492C38.998 95.0492 40.0093 95.7156 40.7735 95.1378C41.5377 94.5599 41.2069 93.544 42.521 92.9615C43.8351 92.379 45.6152 92.5188 46.1651 91.9643C46.715 91.4098 46.1651 91.0789 47.5957 90.9298C49.0264 90.7807 51.2072 91.2001 52.046 89.7881Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M49.242 94.9922C49.242 94.9922 48.4125 95.4582 48.3753 96.1339C48.338 96.8096 49.0323 98.1563 48.6735 98.4173C48.3147 98.6783 47.3594 98.5058 47.3594 98.5058",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0433 99.6438C46.7814 99.7251 46.4986 99.7056 46.2503 99.5893C46.002 99.4729 45.8062 99.2679 45.7012 99.0146",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1573 93.6221C48.1573 93.6221 47.6401 92.9045 46.2188 93.0023",
    stroke: "#263238",
    strokeWidth: 0.932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8965 94.3731C49.8965 94.3731 50.465 94.0376 50.7772 94.8857",
    stroke: "#263238",
    strokeWidth: 0.932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2668 95.1514C46.127 95.4683 46.1223 95.7758 46.2668 95.8364C46.4112 95.897 46.6302 95.692 46.7747 95.3704C46.9192 95.0489 46.9145 94.746 46.7747 94.6854C46.6349 94.6248 46.4066 94.8299 46.2668 95.1514Z",
    fill: "#263238"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5558 96.0088C49.416 96.3257 49.4114 96.6333 49.5558 96.6938C49.7003 96.7544 49.9193 96.5494 50.0638 96.2278C50.2082 95.9063 50.2036 95.6034 50.0638 95.5428C49.924 95.4822 49.6956 95.6873 49.5558 96.0088Z",
    fill: "#263238"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4746 123.256C43.4746 123.256 45.6601 123.102 46.0469 123.256C46.4337 123.41 50.609 124.91 51.1263 125.427C51.9349 126.33 52.6616 127.304 53.2978 128.335C53.9549 129.496 53.6054 129.496 53.4143 129.496C53.2306 129.438 53.0608 129.342 52.9157 129.216C52.7705 129.089 52.6531 128.934 52.5709 128.759C52.1453 128.188 51.678 127.649 51.1729 127.147L50.2782 126.732C50.2782 126.732 51.1729 128.368 51.6762 129.141C52.1794 129.915 52.473 130.362 52.1841 130.507C51.7181 130.735 51.1729 129.948 50.9818 129.691C50.7908 129.435 50.2595 128.89 50.2595 128.89C50.2595 128.89 50.8373 130.05 50.7721 130.246C50.7069 130.442 50.2455 130.544 49.8681 129.985C49.7096 129.747 48.0041 127.683 48.0041 127.683C48.3321 128.345 48.6154 129.029 48.8522 129.729C48.8522 129.985 48.5959 130.05 48.0786 129.729C47.5614 129.407 46.8717 127.804 46.6154 127.482C46.3548 127.253 46.0288 127.111 45.6834 127.077C45.2287 126.975 44.7931 126.802 44.3926 126.564C44.1223 126.276 43.605 125.81 43.605 125.81L42.207 126.392L42.3096 123.559L43.4746 123.256Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9823 127.66L47.3672 126.504",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2507 128.867L48.5078 126.159",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2934 126.741L49.7109 125.776",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5051 111.769L32.0391 123.191L43.7171 122.93L43.6518 127.837C43.6518 127.837 35.3337 129.189 31.2003 129.063C27.0669 128.937 24.6204 129.319 24.2989 128.802C23.9773 128.285 26.4052 108.055 26.4052 108.055C26.4052 108.055 26.792 104.831 27.435 104.64C28.0781 104.449 32.095 103.19 32.095 103.19",
    fill: "#008080"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5051 111.769L32.0391 123.191L43.7171 122.93L43.6518 127.837C43.6518 127.837 35.3337 129.189 31.2003 129.063C27.0669 128.937 24.6204 129.319 24.2989 128.802C23.9773 128.285 26.4052 108.055 26.4052 108.055C26.4052 108.055 26.792 104.831 27.435 104.64C28.0781 104.449 32.095 103.19 32.095 103.19",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1076 123.303L27.5391 123.321",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M32.053 123.19L28.8516 123.279",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5684 196.678C41.5684 195.937 41.6476 194.889 41.7035 194.194C43.3531 195.807 46.7177 199.017 47.5052 199.199C48.2551 199.305 49.0197 199.22 49.728 198.952C50.7812 199.674 52.2444 200.62 51.9695 201.175C51.5687 201.977 45.9674 201.175 45.9674 201.175C45.3724 200.085 44.5547 199.132 43.5675 198.379C43.179 198.077 42.749 197.832 42.2907 197.652L43.5675 198.379L42.5656 201.222H41.5963V197.256L41.6709 197.298C41.5828 197.104 41.5474 196.89 41.5684 196.678Z",
    fill: "#263238"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5675 198.379C44.5547 199.132 45.3724 200.085 45.9674 201.175C45.9674 201.175 51.5687 201.977 51.9695 201.175C52.2444 200.62 50.7812 199.674 49.728 198.952C49.0197 199.22 48.2551 199.305 47.5052 199.199C46.7177 199.017 43.3531 195.807 41.7035 194.194C41.6476 194.889 41.5684 195.937 41.5684 196.678C41.5474 196.89 41.5828 197.104 41.6709 197.298L41.5963 197.256V201.222H42.5656L43.5675 198.379ZM43.5675 198.379C43.179 198.077 42.749 197.832 42.2907 197.652L43.5675 198.379Z",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8359 195.709C34.8359 195.09 35.041 195.243 35.0736 194.801C35.973 196.12 37.9395 199.093 38.522 199.288C39.249 199.531 40.5444 199.204 40.5444 199.204L40.6749 199.265C40.9685 199.834 41.3599 200.579 41.5417 200.849C41.8446 201.315 41.3879 201.781 40.7728 201.781H38.9833C38.6009 201.783 38.2244 201.687 37.8887 201.504C37.5531 201.321 37.2692 201.055 37.0634 200.733C36.9656 200.579 36.8584 200.411 36.7465 200.267L36.4157 201.418H34.8779V196.287L34.8359 195.709Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7788 131.447H74.6641V130.348H51.7788V131.447Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8198 131.447H81.7051V117.365H58.8198V131.447Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M107.312 132.432H243.198",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M107.312 129.632H243.198",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M107.312 126.825H243.198",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M107.312 124.021H243.198",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M107.312 121.216H243.198",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M107.312 118.41H243.198",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M107.312 115.604H243.198",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M107.312 112.799H243.198",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M107.312 109.994H243.198",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M107.312 107.188H243.198",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M107.312 104.384H243.198",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M107.312 101.578H243.198",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M107.312 98.7734H243.198",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M107.312 95.9668H243.198",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M107.312 93.1621H243.198",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M107.312 90.3613H243.198",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M117.285 87.2441H111.986V132.125H117.285V87.2441Z",
    fill: "#008080"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M124.298 111.551H119V132.12H124.298V111.551Z",
    fill: "#008080"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M131.312 115.293H126.014V132.125H131.312V115.293Z",
    fill: "#008080"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M138.324 93.7861H133.025V132.119H138.324V93.7861Z",
    fill: "#008080"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M145.337 112.799H140.039V132.124H145.337V112.799Z",
    fill: "#008080"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M152.351 104.071H147.053V132.12H152.351V104.071Z",
    fill: "#008080"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M159.359 93.1621H154.061V132.12H159.359V93.1621Z",
    fill: "#008080"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M166.373 81.3213H161.074V132.125H166.373V81.3213Z",
    fill: "#008080"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M173.388 105.632H168.09V132.124H173.388V105.632Z",
    fill: "#008080"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M180.402 116.849H175.104V132.119H180.402V116.849Z",
    fill: "#008080"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M187.414 123.084H182.115V132.124H187.414V123.084Z",
    fill: "#008080"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M194.423 115.917H189.125V132.124H194.423V115.917Z",
    fill: "#008080"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M201.435 100.334H196.137V132.124H201.435V100.334Z",
    fill: "#008080"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M208.449 126.514H203.15V132.124H208.449V126.514Z",
    fill: "#008080"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M215.462 115.293H210.164V132.125H215.462V115.293Z",
    fill: "#008080"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M222.474 122.771H217.176V132.119H222.474V122.771Z",
    fill: "#008080"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M229.488 81.6328H224.189V132.124H229.488V81.6328Z",
    fill: "#008080"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M236.496 90.3613H231.197V132.124H236.496V90.3613Z",
    fill: "#008080"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M109.372 75.2117V74.7783H110.127V75.2117C110.779 75.3468 111.115 75.8501 111.115 76.6423V76.8287H110.243V76.5864C110.243 76.167 110.075 76.0086 109.777 76.0086C109.479 76.0086 109.311 76.167 109.311 76.5864C109.311 77.7887 111.105 77.8493 111.105 79.5222C111.105 80.3144 110.765 80.827 110.113 80.9575V81.3862H109.358V80.9575C108.701 80.827 108.365 80.3144 108.365 79.5222V79.1168H109.232V79.5828C109.232 80.0022 109.418 80.1513 109.698 80.1513C109.978 80.1513 110.164 80.0022 110.164 79.5828C110.164 78.3805 108.365 78.3199 108.365 76.647C108.403 75.8594 108.729 75.3562 109.372 75.2117Z",
    fill: "#263238"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M113.086 75.9484C112.793 75.9484 112.62 76.1068 112.62 76.5262V77.1507H111.749V76.5822C111.749 75.6502 112.215 75.1143 113.119 75.1143C114.023 75.1143 114.494 75.6455 114.494 76.5822C114.494 78.4229 112.662 79.1079 112.662 80.0725C112.66 80.1144 112.66 80.1564 112.662 80.1983H114.405V81.0325H111.744V80.3148C111.744 78.5906 113.566 78.3064 113.566 76.6194C113.562 76.0649 113.38 75.9484 113.086 75.9484Z",
    fill: "#263238"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M114.973 76.5587C114.973 75.6267 115.467 75.0908 116.371 75.0908C117.275 75.0908 117.769 75.6221 117.769 76.5587V79.6064C117.769 80.5384 117.275 81.0743 116.371 81.0743C115.467 81.0743 114.973 80.5384 114.973 79.6064V76.5587ZM115.905 79.6623C115.905 80.0817 116.086 80.2401 116.371 80.2401C116.655 80.2401 116.837 80.0817 116.837 79.6623V76.5028C116.837 76.0834 116.655 75.925 116.371 75.925C116.086 75.925 115.905 76.0834 115.905 76.5028V79.6623Z",
    fill: "#263238"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M119.247 80.1426V81.028H118.361V80.1426H119.247Z",
    fill: "#263238"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M121.687 76.596C121.687 76.0648 121.501 75.925 121.221 75.925C120.942 75.925 120.755 76.0834 120.755 76.5028V76.8803H119.889V76.5587C119.889 75.6267 120.355 75.0908 121.259 75.0908C122.163 75.0908 122.629 75.6221 122.629 76.5587V76.7125C122.629 77.3369 122.428 77.733 121.986 77.9148C122.208 78.0266 122.39 78.2055 122.506 78.4262C122.621 78.647 122.664 78.8984 122.629 79.145V79.611C122.629 80.543 122.163 81.0789 121.259 81.0789C120.355 81.0789 119.889 80.543 119.889 79.611V79.145H120.727V79.6763C120.727 80.0957 120.914 80.2541 121.193 80.2541C121.473 80.2541 121.659 80.1096 121.659 79.5924V79.1264C121.659 78.5858 121.473 78.3854 121.058 78.3854H120.746V77.5466H121.105C121.45 77.5466 121.659 77.3975 121.659 76.9315L121.687 76.596Z",
    fill: "#263238"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M123.165 76.61C123.165 75.6221 123.631 75.0908 124.563 75.0908C125.495 75.0908 125.933 75.6221 125.933 76.5587V76.7125H125.061V76.5028C125.061 76.0834 124.88 75.925 124.595 75.925C124.311 75.925 124.083 76.0834 124.083 76.6426V77.7144C124.156 77.5513 124.278 77.4145 124.431 77.3221C124.584 77.2297 124.762 77.1861 124.94 77.1971C125.616 77.1971 125.956 77.6631 125.956 78.5346V79.6064C125.956 80.5384 125.467 81.0743 124.558 81.0743C123.649 81.0743 123.16 80.5384 123.16 79.6064L123.165 76.61ZM124.097 78.6091V79.6763C124.097 80.0957 124.283 80.2448 124.563 80.2448C124.842 80.2448 125.029 80.0957 125.029 79.6763V78.6231C125.029 78.2037 124.847 78.0453 124.563 78.0453C124.279 78.0453 124.083 78.1897 124.083 78.6091H124.097Z",
    fill: "#263238"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M127.855 81.0733C127.659 81.0929 127.461 81.0682 127.276 81.0009C127.09 80.9336 126.923 80.8254 126.785 80.6844C126.647 80.5434 126.542 80.3733 126.479 80.1865C126.416 79.9997 126.396 79.8011 126.42 79.6054V79.1394C126.393 78.9032 126.431 78.6641 126.532 78.4486C126.632 78.233 126.79 78.0495 126.988 77.9185C126.791 77.797 126.632 77.6213 126.531 77.4123C126.431 77.2033 126.392 76.9698 126.42 76.7395V76.5531C126.409 76.3574 126.438 76.1615 126.505 75.9774C126.572 75.7933 126.676 75.6248 126.811 75.4824C126.945 75.3399 127.108 75.2264 127.288 75.1488C127.468 75.0713 127.662 75.0312 127.858 75.0312C128.054 75.0312 128.248 75.0713 128.427 75.1488C128.607 75.2264 128.77 75.3399 128.904 75.4824C129.039 75.6248 129.143 75.7933 129.21 75.9774C129.277 76.1615 129.306 76.3574 129.295 76.5531V76.7395C129.322 76.9696 129.282 77.2025 129.181 77.4112C129.081 77.6199 128.923 77.7958 128.727 77.9185C128.925 78.0495 129.083 78.233 129.184 78.4486C129.284 78.6641 129.323 78.9032 129.295 79.1394V79.6054C129.318 79.8013 129.297 80 129.234 80.1868C129.17 80.3735 129.065 80.5436 128.927 80.6845C128.789 80.8253 128.621 80.9334 128.435 81.0007C128.25 81.068 128.052 81.0928 127.855 81.0733ZM127.338 76.9212C127.338 77.3872 127.557 77.5363 127.855 77.5363C128.153 77.5363 128.377 77.3872 128.377 76.9212V76.595C128.377 76.0638 128.149 75.924 127.855 75.924C127.562 75.924 127.338 76.0638 127.338 76.595V76.9212ZM127.855 80.2391C128.149 80.2391 128.368 80.0947 128.377 79.5774V79.0322C128.377 78.5662 128.181 78.3751 127.855 78.3751C127.529 78.3751 127.338 78.5755 127.338 79.0322V79.5774C127.338 80.0947 127.566 80.2391 127.855 80.2391Z",
    fill: "#263238"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M129.844 81.0093V80.1426H130.734V80.9348L130.328 81.8668H129.956L130.198 81.0326L129.844 81.0093Z",
    fill: "#263238"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M132.745 75.9484C132.452 75.9484 132.279 76.1068 132.279 76.5262V77.1507H131.398V76.5822C131.398 75.6502 131.864 75.1143 132.768 75.1143C133.673 75.1143 134.166 75.6455 134.166 76.5822C134.166 78.4229 132.335 79.1079 132.335 80.0725C132.333 80.1144 132.333 80.1564 132.335 80.1983H134.078V81.0325H131.398V80.3148C131.398 78.5906 133.22 78.3064 133.22 76.6194C133.22 76.0649 133.039 75.9484 132.745 75.9484Z",
    fill: "#263238"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M136.484 76.596C136.484 76.0648 136.298 75.925 136.018 75.925C135.739 75.925 135.552 76.0834 135.552 76.5028V76.8803H134.662V76.5587C134.662 75.6267 135.128 75.0908 136.032 75.0908C136.936 75.0908 137.402 75.6221 137.402 76.5587V76.7125C137.402 77.3369 137.202 77.733 136.759 77.9148C136.982 78.0266 137.164 78.2055 137.279 78.4262C137.394 78.647 137.437 78.8984 137.402 79.145V79.611C137.402 80.543 136.936 81.0789 136.032 81.0789C135.128 81.0789 134.662 80.543 134.662 79.611V79.145H135.529V79.6763C135.529 80.0957 135.715 80.2541 135.995 80.2541C136.274 80.2541 136.461 80.1096 136.461 79.5924V79.1264C136.461 78.5858 136.274 78.3854 135.86 78.3854H135.548V77.5466H135.906C136.251 77.5466 136.461 77.3975 136.461 76.9315L136.484 76.596Z",
    fill: "#263238"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M289.662 75.9111H246.264V132.297H289.662V75.9111Z",
    fill: "#263238"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M253.775 79.373H259.521",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M262.756 79.373H268.502",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M271.736 79.373H277.482",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M280.711 79.373H286.457",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M261.164 76.7549V131.519",
    stroke: "white",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M252.172 76.7549V131.519",
    stroke: "white",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M270.295 76.7549V131.519",
    stroke: "white",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M279.43 76.7549V131.519",
    stroke: "white",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M249.536 78.2588L248.482 80.0902H250.593L249.536 78.2588Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M253.775 83.6191H259.521",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M262.756 83.6191H268.502",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M271.736 83.6191H277.482",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M280.711 83.6191H286.457",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M249.536 84.3363L250.593 82.5049H248.482L249.536 84.3363Z",
    fill: "#008080"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M253.775 87.8594H259.521",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M262.756 87.8594H268.502",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M271.736 87.8594H277.482",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M280.711 87.8594H286.457",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M249.536 86.75L248.482 88.5814H250.593L249.536 86.75Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M253.775 92.1035H259.521",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M262.756 92.1035H268.502",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M271.736 92.1035H277.482",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M280.711 92.1035H286.457",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M249.536 92.8218L250.593 90.9951H248.482L249.536 92.8218Z",
    fill: "#008080"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M253.775 96.3496H259.521",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M262.756 96.3496H268.502",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M271.736 96.3496H277.482",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M280.711 96.3496H286.457",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M249.536 97.067L250.593 95.2402H248.482L249.536 97.067Z",
    fill: "#008080"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M253.775 100.596H259.521",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M262.756 100.596H268.502",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M271.736 100.596H277.482",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M280.711 100.596H286.457",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M249.536 101.312L250.593 99.4854H248.482L249.536 101.312Z",
    fill: "#008080"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M253.775 104.84H259.521",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M262.756 104.84H268.502",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M271.736 104.84H277.482",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M280.711 104.84H286.457",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M249.536 103.727L248.482 105.558H250.593L249.536 103.727Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M253.775 109.086H259.521",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M262.756 109.086H268.502",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M271.736 109.086H277.482",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M280.711 109.086H286.457",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M249.536 107.972L248.482 109.803H250.593L249.536 107.972Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M253.775 113.33H259.521",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M262.756 113.33H268.502",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M271.736 113.33H277.482",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M280.711 113.33H286.457",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M249.536 114.048L250.593 112.217H248.482L249.536 114.048Z",
    fill: "#008080"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M253.775 117.571H259.521",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M262.756 117.571H268.502",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M271.736 117.571H277.482",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M280.711 117.571H286.457",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M249.536 116.462L248.482 118.293H250.593L249.536 116.462Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M253.775 121.816H259.521",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M262.756 121.816H268.502",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M271.736 121.816H277.482",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M280.711 121.816H286.457",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M249.536 122.535L250.593 120.708H248.482L249.536 122.535Z",
    fill: "#008080"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M247.898 81.335H288.538",
    stroke: "white",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M247.898 85.5801H288.538",
    stroke: "white",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M247.898 89.8252H288.538",
    stroke: "white",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M247.898 94.0713H288.538",
    stroke: "white",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M247.898 98.3154H288.538",
    stroke: "white",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M247.898 102.562H288.538",
    stroke: "white",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M247.898 106.802H288.538",
    stroke: "white",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M247.898 111.047H288.538",
    stroke: "white",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M247.898 115.293H288.538",
    stroke: "white",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M247.898 119.537H288.538",
    stroke: "white",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M247.898 123.783H288.538",
    stroke: "white",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M247.898 128.027H288.538",
    stroke: "white",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M253.775 126.062H259.521",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M262.756 126.062H268.502",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M271.736 126.062H277.482",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M280.711 126.062H286.457",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M249.536 124.952L248.482 126.779H250.593L249.536 124.952Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M253.775 130.307H259.521",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M262.756 130.307H268.502",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M271.736 130.307H277.482",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M280.711 130.307H286.457",
    stroke: "#757575",
    strokeWidth: 0.466,
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M249.536 131.024L250.593 129.192H248.482L249.536 131.024Z",
    fill: "#008080"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M238.963 148.491C238.963 147.768 239.294 147.377 239.993 147.377C240.692 147.377 240.995 147.768 240.995 148.453V148.565H240.357V148.411C240.357 148.104 240.226 147.987 240.012 147.987C239.797 147.987 239.639 148.104 239.639 148.514V149.297C239.691 149.178 239.779 149.078 239.889 149.011C240 148.943 240.129 148.911 240.259 148.919C240.757 148.919 241.009 149.269 241.009 149.898V150.681C241.018 150.821 240.999 150.962 240.952 151.094C240.905 151.226 240.831 151.347 240.735 151.45C240.639 151.553 240.523 151.634 240.394 151.69C240.266 151.746 240.127 151.775 239.986 151.775C239.846 151.775 239.707 151.746 239.578 151.69C239.449 151.634 239.333 151.553 239.237 151.45C239.141 151.347 239.067 151.226 239.02 151.094C238.973 150.962 238.954 150.821 238.963 150.681V148.491ZM239.639 149.954V150.723C239.639 151.03 239.769 151.142 239.984 151.142C240.198 151.142 240.333 151.03 240.333 150.723V149.954C240.333 149.646 240.198 149.53 239.984 149.53C239.769 149.53 239.639 149.646 239.639 149.954Z",
    fill: "#263238"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M241.377 148.454C241.368 148.314 241.387 148.173 241.434 148.041C241.482 147.908 241.555 147.787 241.651 147.684C241.747 147.582 241.863 147.5 241.992 147.444C242.121 147.388 242.26 147.359 242.4 147.359C242.541 147.359 242.68 147.388 242.808 147.444C242.937 147.5 243.053 147.582 243.149 147.684C243.245 147.787 243.319 147.908 243.366 148.041C243.413 148.173 243.433 148.314 243.423 148.454V150.681C243.433 150.821 243.413 150.962 243.366 151.094C243.319 151.226 243.245 151.348 243.149 151.45C243.053 151.553 242.937 151.635 242.808 151.691C242.68 151.747 242.541 151.775 242.4 151.775C242.26 151.775 242.121 151.747 241.992 151.691C241.863 151.635 241.747 151.553 241.651 151.45C241.555 151.348 241.482 151.226 241.434 151.094C241.387 150.962 241.368 150.821 241.377 150.681V148.454ZM242.048 150.723C242.048 151.031 242.184 151.147 242.398 151.147C242.612 151.147 242.747 151.031 242.747 150.723V148.393C242.747 148.086 242.612 147.969 242.398 147.969C242.184 147.969 242.048 148.086 242.048 148.393V150.723Z",
    fill: "#263238"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M243.819 148.08C243.811 147.99 243.822 147.899 243.851 147.813C243.881 147.728 243.927 147.65 243.988 147.583C244.05 147.517 244.124 147.463 244.206 147.427C244.289 147.391 244.378 147.372 244.469 147.372C244.559 147.372 244.648 147.391 244.731 147.427C244.814 147.463 244.888 147.517 244.949 147.583C245.01 147.65 245.057 147.728 245.086 147.813C245.115 147.899 245.126 147.99 245.119 148.08V149.478C245.126 149.568 245.115 149.658 245.086 149.744C245.057 149.829 245.01 149.908 244.949 149.974C244.888 150.041 244.814 150.094 244.731 150.13C244.648 150.166 244.559 150.185 244.469 150.185C244.378 150.185 244.289 150.166 244.206 150.13C244.124 150.094 244.05 150.041 243.988 149.974C243.927 149.908 243.881 149.829 243.851 149.744C243.822 149.658 243.811 149.568 243.819 149.478V148.08ZM244.247 149.519C244.247 149.706 244.327 149.785 244.466 149.785C244.606 149.785 244.69 149.706 244.69 149.519V148.047C244.69 147.856 244.602 147.777 244.466 147.777C244.331 147.777 244.247 147.856 244.247 148.047V149.519ZM246.158 147.422H246.549L244.863 151.71H244.462L246.158 147.422ZM245.944 149.645C245.936 149.555 245.947 149.465 245.976 149.379C246.006 149.294 246.052 149.215 246.113 149.149C246.174 149.082 246.249 149.029 246.331 148.993C246.414 148.957 246.503 148.938 246.594 148.938C246.684 148.938 246.773 148.957 246.856 148.993C246.939 149.029 247.013 149.082 247.074 149.149C247.135 149.215 247.182 149.294 247.211 149.379C247.24 149.465 247.251 149.555 247.244 149.645V151.043C247.251 151.133 247.24 151.224 247.211 151.309C247.182 151.395 247.135 151.473 247.074 151.54C247.013 151.606 246.939 151.659 246.856 151.696C246.773 151.732 246.684 151.751 246.594 151.751C246.503 151.751 246.414 151.732 246.331 151.696C246.249 151.659 246.174 151.606 246.113 151.54C246.052 151.473 246.006 151.395 245.976 151.309C245.947 151.224 245.936 151.133 245.944 151.043V149.645ZM246.372 151.085C246.372 151.276 246.452 151.356 246.591 151.356C246.731 151.356 246.815 151.276 246.815 151.085V149.613C246.815 149.426 246.727 149.347 246.591 149.347C246.456 149.347 246.372 149.426 246.372 149.613V151.085Z",
    fill: "#263238"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M240.304 155.21C240.304 154.824 240.169 154.744 239.955 154.744C239.741 154.744 239.605 154.856 239.605 155.164V155.439H238.967V155.168C238.944 155.028 238.954 154.884 238.996 154.748C239.037 154.612 239.109 154.487 239.206 154.383C239.303 154.279 239.423 154.199 239.556 154.149C239.689 154.098 239.832 154.079 239.974 154.092C240.635 154.092 240.975 154.483 240.975 155.168V155.28C241.003 155.458 240.972 155.639 240.888 155.798C240.804 155.956 240.672 156.084 240.509 156.161C240.671 156.244 240.802 156.375 240.886 156.536C240.969 156.698 241 156.881 240.975 157.06V157.401C240.975 158.086 240.635 158.477 239.974 158.477C239.832 158.49 239.689 158.471 239.556 158.42C239.423 158.37 239.303 158.289 239.206 158.186C239.109 158.082 239.037 157.957 238.996 157.821C238.954 157.685 238.944 157.541 238.967 157.401V157.042H239.605V157.442C239.605 157.745 239.741 157.862 239.955 157.862C240.169 157.862 240.304 157.759 240.304 157.396V157.056C240.304 156.66 240.169 156.51 239.838 156.51H239.615V155.9H239.876C240.127 155.9 240.281 155.788 240.281 155.434L240.304 155.21Z",
    fill: "#263238"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M241.377 155.168C241.368 155.028 241.387 154.888 241.434 154.755C241.482 154.623 241.555 154.502 241.651 154.399C241.747 154.297 241.863 154.215 241.992 154.159C242.121 154.103 242.26 154.074 242.4 154.074C242.541 154.074 242.68 154.103 242.808 154.159C242.937 154.215 243.053 154.297 243.149 154.399C243.245 154.502 243.319 154.623 243.366 154.755C243.413 154.888 243.433 155.028 243.423 155.168V157.401C243.433 157.541 243.413 157.681 243.366 157.814C243.319 157.946 243.245 158.067 243.149 158.17C243.053 158.272 242.937 158.354 242.808 158.41C242.68 158.466 242.541 158.495 242.4 158.495C242.26 158.495 242.121 158.466 241.992 158.41C241.863 158.354 241.747 158.272 241.651 158.17C241.555 158.067 241.482 157.946 241.434 157.814C241.387 157.681 241.368 157.541 241.377 157.401V155.168ZM242.048 157.443C242.048 157.745 242.184 157.862 242.398 157.862C242.612 157.862 242.747 157.745 242.747 157.443V155.113C242.747 154.805 242.612 154.693 242.398 154.693C242.184 154.693 242.048 154.805 242.048 155.113V157.443Z",
    fill: "#263238"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M243.819 154.809C243.811 154.719 243.822 154.628 243.851 154.543C243.881 154.458 243.927 154.379 243.988 154.313C244.05 154.246 244.124 154.193 244.206 154.157C244.289 154.12 244.378 154.102 244.469 154.102C244.559 154.102 244.648 154.12 244.731 154.157C244.814 154.193 244.888 154.246 244.949 154.313C245.01 154.379 245.057 154.458 245.086 154.543C245.115 154.628 245.126 154.719 245.119 154.809V156.207C245.126 156.297 245.115 156.388 245.086 156.473C245.057 156.559 245.01 156.637 244.949 156.704C244.888 156.77 244.814 156.823 244.731 156.859C244.648 156.896 244.559 156.915 244.469 156.915C244.378 156.915 244.289 156.896 244.206 156.859C244.124 156.823 244.05 156.77 243.988 156.704C243.927 156.637 243.881 156.559 243.851 156.473C243.822 156.388 243.811 156.297 243.819 156.207V154.809ZM244.247 156.249C244.247 156.44 244.327 156.519 244.466 156.519C244.606 156.519 244.69 156.44 244.69 156.249V154.781C244.69 154.59 244.602 154.511 244.466 154.511C244.331 154.511 244.247 154.59 244.247 154.781V156.249ZM246.158 154.157H246.549L244.867 158.43H244.466L246.158 154.157ZM245.944 156.375C245.936 156.285 245.947 156.194 245.976 156.109C246.006 156.023 246.052 155.945 246.113 155.878C246.174 155.812 246.249 155.759 246.331 155.722C246.414 155.686 246.503 155.667 246.594 155.667C246.684 155.667 246.773 155.686 246.856 155.722C246.939 155.759 247.013 155.812 247.074 155.878C247.135 155.945 247.182 156.023 247.211 156.109C247.24 156.194 247.251 156.285 247.244 156.375V157.773C247.251 157.863 247.24 157.953 247.211 158.039C247.182 158.124 247.135 158.203 247.074 158.269C247.013 158.336 246.939 158.389 246.856 158.425C246.773 158.462 246.684 158.48 246.594 158.48C246.503 158.48 246.414 158.462 246.331 158.425C246.249 158.389 246.174 158.336 246.113 158.269C246.052 158.203 246.006 158.124 245.976 158.039C245.947 157.953 245.936 157.863 245.944 157.773V156.375ZM246.372 157.815C246.372 158.006 246.452 158.085 246.591 158.085C246.731 158.085 246.815 158.006 246.815 157.815V156.347C246.815 156.156 246.727 156.077 246.591 156.077C246.456 156.077 246.372 156.156 246.372 156.347V157.815Z",
    fill: "#263238"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M239.992 161.449C239.778 161.449 239.643 161.565 239.643 161.873V162.339H239.004V161.924C238.981 161.784 238.991 161.64 239.033 161.504C239.074 161.368 239.146 161.243 239.243 161.139C239.341 161.035 239.46 160.955 239.593 160.904C239.726 160.854 239.869 160.835 240.011 160.848C240.668 160.848 241.013 161.239 241.013 161.924C241.013 163.271 239.67 163.788 239.67 164.478C239.666 164.507 239.666 164.537 239.67 164.566H240.957V165.182H239.009V164.655C239.009 163.392 240.346 163.182 240.346 161.948C240.342 161.551 240.206 161.449 239.992 161.449Z",
    fill: "#263238"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M241.377 161.916C241.368 161.775 241.387 161.635 241.434 161.503C241.482 161.37 241.555 161.249 241.651 161.146C241.747 161.044 241.863 160.962 241.992 160.906C242.121 160.85 242.26 160.821 242.4 160.821C242.541 160.821 242.68 160.85 242.808 160.906C242.937 160.962 243.053 161.044 243.149 161.146C243.245 161.249 243.319 161.37 243.366 161.503C243.413 161.635 243.433 161.775 243.423 161.916V164.143C243.433 164.283 243.413 164.424 243.366 164.556C243.319 164.688 243.245 164.81 243.149 164.912C243.053 165.015 242.937 165.097 242.808 165.153C242.68 165.208 242.541 165.237 242.4 165.237C242.26 165.237 242.121 165.208 241.992 165.153C241.863 165.097 241.747 165.015 241.651 164.912C241.555 164.81 241.482 164.688 241.434 164.556C241.387 164.424 241.368 164.283 241.377 164.143V161.916ZM242.048 164.185C242.048 164.493 242.184 164.609 242.398 164.609C242.612 164.609 242.747 164.493 242.747 164.185V161.855C242.747 161.547 242.612 161.431 242.398 161.431C242.184 161.431 242.048 161.547 242.048 161.855V164.185Z",
    fill: "#263238"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M243.819 161.542C243.811 161.452 243.822 161.362 243.851 161.276C243.881 161.191 243.927 161.112 243.988 161.046C244.05 160.979 244.124 160.926 244.206 160.89C244.289 160.854 244.378 160.835 244.469 160.835C244.559 160.835 244.648 160.854 244.731 160.89C244.814 160.926 244.888 160.979 244.949 161.046C245.01 161.112 245.057 161.191 245.086 161.276C245.115 161.362 245.126 161.452 245.119 161.542V162.94C245.126 163.03 245.115 163.121 245.086 163.207C245.057 163.292 245.01 163.37 244.949 163.437C244.888 163.503 244.814 163.557 244.731 163.593C244.648 163.629 244.559 163.648 244.469 163.648C244.378 163.648 244.289 163.629 244.206 163.593C244.124 163.557 244.05 163.503 243.988 163.437C243.927 163.37 243.881 163.292 243.851 163.207C243.822 163.121 243.811 163.03 243.819 162.94V161.542ZM244.247 162.978C244.247 163.169 244.327 163.248 244.466 163.248C244.606 163.248 244.69 163.169 244.69 162.978V161.51C244.69 161.319 244.602 161.24 244.466 161.24C244.331 161.24 244.247 161.319 244.247 161.51V162.978ZM246.158 160.885H246.549L244.863 165.173H244.462L246.158 160.885ZM245.944 163.09C245.936 163 245.947 162.909 245.976 162.824C246.006 162.738 246.052 162.66 246.113 162.593C246.174 162.527 246.249 162.473 246.331 162.437C246.414 162.401 246.503 162.382 246.594 162.382C246.684 162.382 246.773 162.401 246.856 162.437C246.939 162.473 247.013 162.527 247.074 162.593C247.135 162.66 247.182 162.738 247.211 162.824C247.24 162.909 247.251 163 247.244 163.09V164.488C247.251 164.578 247.24 164.668 247.211 164.754C247.182 164.839 247.135 164.918 247.074 164.984C247.013 165.051 246.939 165.104 246.856 165.14C246.773 165.176 246.684 165.195 246.594 165.195C246.503 165.195 246.414 165.176 246.331 165.14C246.249 165.104 246.174 165.051 246.113 164.984C246.052 164.918 246.006 164.839 245.976 164.754C245.947 164.668 245.936 164.578 245.944 164.488V163.09ZM246.372 164.53C246.372 164.721 246.452 164.8 246.591 164.8C246.731 164.8 246.815 164.721 246.815 164.53V163.09C246.815 162.903 246.727 162.824 246.591 162.824C246.456 162.824 246.372 162.903 246.372 163.09V164.53Z",
    fill: "#263238"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M210.373 165.844C209.17 165.074 208.136 164.067 207.336 162.883C206.536 161.7 205.986 160.365 205.719 158.962C205.453 157.558 205.476 156.115 205.787 154.721C206.098 153.327 206.69 152.011 207.527 150.853C208.365 149.696 209.43 148.722 210.657 147.99C211.884 147.259 213.248 146.786 214.664 146.6C216.081 146.414 217.52 146.519 218.894 146.909C220.269 147.299 221.549 147.966 222.657 148.868",
    stroke: "#263238",
    strokeWidth: 2.796,
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M224.404 163.379C222.803 165.478 220.471 166.897 217.87 167.354C215.27 167.811 212.594 167.272 210.373 165.844",
    stroke: "#757575",
    strokeWidth: 2.796,
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M222.658 148.867C224.779 150.584 226.147 153.06 226.474 155.769C226.8 158.478 226.058 161.207 224.406 163.378",
    stroke: "#008080",
    strokeWidth: 2.796,
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M234.27 151.617C235.253 151.617 236.05 150.82 236.05 149.837C236.05 148.854 235.253 148.057 234.27 148.057C233.287 148.057 232.49 148.854 232.49 149.837C232.49 150.82 233.287 151.617 234.27 151.617Z",
    fill: "#263238"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M234.27 158.15C235.253 158.15 236.05 157.353 236.05 156.37C236.05 155.387 235.253 154.59 234.27 154.59C233.287 154.59 232.49 155.387 232.49 156.37C232.49 157.353 233.287 158.15 234.27 158.15Z",
    fill: "#C4F0D1"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M234.27 164.684C235.253 164.684 236.05 163.887 236.05 162.904C236.05 161.921 235.253 161.124 234.27 161.124C233.287 161.124 232.49 161.921 232.49 162.904C232.49 163.887 233.287 164.684 234.27 164.684Z",
    fill: "#757575"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M248.146 138.458H206.938V139.87H248.146V138.458Z",
    fill: "#CCCCCC"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 143.131H195.588",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 146.976H195.588",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 150.82H195.588",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 154.665H195.588",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 158.509H195.588",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 162.354H195.588",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 166.198H195.588",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 170.043H195.588",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M107.633 143.131H111.589",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M107.633 146.976H111.589",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M107.633 150.82H111.589",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M107.633 154.665H111.589",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M107.633 158.509H111.589",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M107.633 162.354H111.589",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M107.633 166.198H111.589",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M107.633 170.043H111.589",
    stroke: "#CCCCCC",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M114.914 151.981L115.893 151.11L116.438 152.419L117.743 151.548L118.181 152.638L119.378 149.479L119.924 150.457L120.25 152.527L121.447 152.965L121.993 154.815L122.757 155.579L123.409 154.05L124.933 157.21L125.585 156.991L127.002 165.053L127.547 163.855L128.526 166.25L130.05 156.884L131.359 159.06L132.45 156.991L133.209 158.734L134.188 157.862L134.952 159.717L136.695 157.862L137.459 160.262L139.197 161.134L140.069 159.06L140.945 158.953L141.704 157.648H142.469L143.009 160.803L143.885 157.536L144.971 157.322L146.061 156.557L147.04 157.21L147.804 160.15L148.564 159.605L149.873 161.786L150.633 160.476L151.29 161.786L151.835 161.348L152.707 161.567L154.338 159.391L155.428 160.588L156.188 158.407L157.059 159.06L157.931 153.836L158.588 154.596L160 149.698H160.545L160.871 147.298L161.961 147.191L162.395 144.796L163.485 147.736L164.138 146.431L164.902 151.329L165.88 151.655L166.426 150.024L168.28 148.715L169.259 151.11L169.366 155.36L170.676 156.012L171.873 153.836L172.852 154.162L174.049 154.05L174.814 155.579L175.685 153.51H176.338L178.407 158.193L178.952 156.557L179.823 156.665L180.909 159.279L182.107 157.429L182.978 148.607L184.176 150.024L184.614 143.053L185.704 144.358L186.249 148.062L187.554 147.517L188.533 150.569L189.297 150.896L189.73 156.557L190.387 155.253L190.714 153.724L192.456 154.162L193.216 153.724L194.633 155.686",
    stroke: "#008080",
    strokeWidth: 0.932,
    strokeMiterlimit: 10
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M117.858 136.336H108.072V141.294H117.858V136.336Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M117.859 136.336V137.515C117.546 137.515 117.246 137.391 117.025 137.17C116.804 136.948 116.68 136.649 116.68 136.336H117.859Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M116.688 141.295C116.688 141.244 116.688 141.193 116.688 141.137C116.688 140.824 116.812 140.524 117.033 140.303C117.254 140.082 117.554 139.958 117.866 139.958",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M116.688 141.295C116.688 141.244 116.688 141.193 116.688 141.137C116.688 140.824 116.812 140.524 117.033 140.303C117.254 140.082 117.554 139.958 117.866 139.958",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M108.072 137.515H108.105C108.418 137.515 108.717 137.391 108.939 137.17C109.16 136.948 109.284 136.649 109.284 136.336",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M108.072 137.515H108.105C108.418 137.515 108.717 137.391 108.939 137.17C109.16 136.948 109.284 136.649 109.284 136.336",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M109.284 141.137C109.284 141.193 109.284 141.244 109.284 141.295H108.082V139.958H108.115C108.426 139.96 108.723 140.086 108.942 140.307C109.161 140.527 109.284 140.826 109.284 141.137Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M114.494 138.816C114.494 138.513 114.405 138.218 114.237 137.966C114.069 137.715 113.83 137.519 113.551 137.403C113.272 137.288 112.964 137.258 112.668 137.316C112.371 137.375 112.099 137.521 111.885 137.735C111.671 137.949 111.526 138.221 111.467 138.517C111.408 138.814 111.438 139.121 111.554 139.401C111.67 139.68 111.865 139.919 112.117 140.086C112.368 140.254 112.664 140.344 112.966 140.344C113.371 140.344 113.76 140.183 114.047 139.896C114.333 139.61 114.494 139.221 114.494 138.816Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M112.839 137.865V137.721H113.091V137.865C113.305 137.907 113.417 138.075 113.417 138.331V138.392H113.128V138.308C113.128 138.173 113.072 138.117 112.975 138.117C112.877 138.117 112.825 138.173 112.825 138.308C112.825 138.709 113.417 138.727 113.417 139.282C113.429 139.386 113.403 139.491 113.343 139.577C113.282 139.663 113.193 139.723 113.091 139.748V139.888H112.839V139.79C112.737 139.766 112.646 139.706 112.585 139.62C112.524 139.534 112.497 139.429 112.509 139.324V139.193H112.807V139.324C112.807 139.459 112.867 139.51 112.965 139.51C113.063 139.51 113.124 139.459 113.124 139.324C113.124 138.923 112.527 138.904 112.527 138.35C112.509 138.245 112.53 138.136 112.588 138.046C112.646 137.956 112.736 137.892 112.839 137.865Z",
    fill: "#263238"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M162.064 138.458H120.855V139.87H162.064V138.458Z",
    fill: "#CCCCCC"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M288.712 142.768H256.441V145.843H288.712V142.768Z",
    fill: "#CCCCCC"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M266.735 142.768H256.441V145.843H266.735V142.768Z",
    fill: "#008080"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M288.712 150.717H256.441V153.792H288.712V150.717Z",
    fill: "#CCCCCC"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M278.022 150.717H256.441V153.792H278.022V150.717Z",
    fill: "#008080"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M288.712 158.668H256.441V161.744H288.712V158.668Z",
    fill: "#CCCCCC"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M260.994 158.668H256.441V161.744H260.994V158.668Z",
    fill: "#008080"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M288.712 166.613H256.441V169.689H288.712V166.613Z",
    fill: "#CCCCCC"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M284.751 166.613H256.441V169.689H284.751V166.613Z",
    fill: "#008080"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M288.503 138.458H256.33V139.87H288.503V138.458Z",
    fill: "#CCCCCC"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M119.181 194.586C128.402 185.365 128.402 170.414 119.181 161.193C109.96 151.972 95.0093 151.972 85.7882 161.193C76.567 170.414 76.567 185.365 85.7882 194.586C95.0093 203.807 109.96 203.807 119.181 194.586Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M114.209 158.205H115.206",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M116.449 159.943H117.815",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M118.938 162.437H120.056",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M121.428 165.797H122.546",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M123.668 170.4H124.912",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M124.727 177.89H126.097",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M114.209 197.279H115.206",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M116.449 195.537H117.815",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M118.938 193.048H120.056",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M121.428 189.688H122.546",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M123.668 185.084H124.912",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M124.116 183.23C127.068 170.527 119.163 157.838 106.46 154.887C93.7581 151.935 81.0684 159.84 78.1171 172.542C75.1659 185.245 83.0707 197.934 95.773 200.886C108.475 203.837 121.165 195.932 124.116 183.23Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M120.786 182.458C123.312 171.596 116.554 160.743 105.692 158.217C94.8303 155.692 83.9776 162.45 81.452 173.311C78.9263 184.173 85.6842 195.026 96.546 197.552C107.408 200.077 118.261 193.319 120.786 182.458Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4366 164.529V162.586H102.796V164.529C105.714 165.13 107.21 167.372 107.21 170.923V171.743H103.323V170.662C103.323 168.798 102.573 168.08 101.268 168.08C99.9632 168.08 99.2083 168.793 99.2083 170.662C99.2083 176.044 107.247 176.305 107.247 183.78C107.247 187.331 105.714 189.609 102.796 190.21V192.116H99.4366V190.21C96.4822 189.609 94.9863 187.331 94.9863 183.78V181.986H98.8728V184.059C98.8728 185.923 99.6976 186.604 101.002 186.604C102.307 186.604 103.137 185.928 103.137 184.059C103.137 178.677 95.0982 178.416 95.0982 170.941C95.0982 167.409 96.5567 165.168 99.4366 164.529Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4378 164.529V162.586H101.802V164.529C104.72 165.13 106.211 167.372 106.211 170.923V171.743H102.324V170.662C102.324 168.798 101.579 168.08 100.269 168.08C98.9597 168.08 98.2141 168.793 98.2141 170.662C98.2141 176.044 106.248 176.305 106.248 183.78C106.248 187.331 104.72 189.609 101.802 190.21V192.116H98.4378V190.21C95.4834 189.609 93.9922 187.331 93.9922 183.78V181.986H97.8926V184.059C97.8926 185.923 98.7128 186.604 100.022 186.604C101.332 186.604 102.152 185.928 102.152 184.059C102.152 178.677 94.118 178.416 94.118 170.941C94.104 167.409 95.5626 165.168 98.4378 164.529Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7076 138.443H93.5879V134.897H53.7076V138.443Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4766 134.979V138.293",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6328 134.979V138.293",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1738 134.979V138.293",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8672 134.979V138.293",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5664 134.979V138.293",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2598 134.979V138.293",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8047 134.979V138.293",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M73.041 134.979V138.293",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7076 142.17H93.5879V138.624H53.7076V142.17Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4766 138.708V142.021",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6328 138.708V142.021",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1738 138.708V142.021",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8672 138.708V142.021",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5664 138.708V142.021",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2598 138.708V142.021",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8047 138.708V142.021",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M73.041 138.708V142.021",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7076 134.775H93.5879V131.229H53.7076V134.775Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4766 131.308V134.616",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6328 131.308V134.616",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1738 131.308V134.616",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8672 131.308V134.616",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5664 131.308V134.616",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2598 131.308V134.616",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8047 131.308V134.616",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M73.041 131.308V134.616",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7076 145.898H93.5879V142.352H53.7076V145.898Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4766 142.436V145.749",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6328 142.436V145.749",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1738 142.436V145.749",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8672 142.436V145.749",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5664 142.436V145.749",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2598 142.436V145.749",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8047 142.436V145.749",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M73.041 142.436V145.749",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6392 149.627H94.5195V146.081H54.6392V149.627Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4082 146.164V149.477",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5625 146.164V149.477",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1055 146.164V149.477",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8008 146.164V149.477",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M85.498 146.164V149.477",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1895 146.164V149.477",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7363 146.164V149.477",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9746 146.164V149.477",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7076 153.354H93.5879V149.808H53.7076V153.354Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4766 149.893V153.206",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6328 149.893V153.206",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1738 149.893V153.206",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8672 149.893V153.206",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5664 149.893V153.206",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2598 149.893V153.206",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8047 149.893V153.206",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M73.041 149.893V153.206",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5709 157.083H95.4512V153.537H55.5709V157.083Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3398 153.62V156.933",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4961 153.62V156.933",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0391 153.62V156.933",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7324 153.62V156.933",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4316 153.62V156.933",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M84.123 153.62V156.933",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6699 153.62V156.933",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9043 153.62V156.933",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2701 160.812H96.1504V157.265H56.2701V160.812Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M94.041 157.348V160.661",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1953 157.348V160.661",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7363 157.348V160.661",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4297 157.348V160.661",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1289 157.348V160.661",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8223 157.348V160.661",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3672 157.348V160.661",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6055 157.348V160.661",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4049 164.538H94.2852V160.992H54.4049V164.538Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1758 161.076V164.389",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3301 161.076V164.389",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M89.873 161.076V164.389",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5684 161.076V164.389",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2656 161.076V164.389",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M82.957 161.076V164.389",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5039 161.076V164.389",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7402 161.076V164.389",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4361 168.267H95.3164V164.72H55.4361V168.267Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2051 164.804V168.117",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3613 164.804V168.117",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9043 164.804V168.117",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5957 164.804V168.117",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2949 164.804V168.117",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9883 164.804V168.117",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5352 164.804V168.117",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7695 164.804V168.117",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7076 171.995H93.5879V168.449H53.7076V171.995Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4766 168.532V171.845",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6328 168.532V171.845",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1738 168.532V171.845",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8672 168.532V171.845",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5664 168.532V171.845",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2598 168.532V171.845",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8047 168.532V171.845",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M73.041 168.532V171.845",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7076 175.723H93.5879V172.176H53.7076V175.723Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4766 172.261V175.574",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6328 172.261V175.574",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1738 172.261V175.574",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8672 172.261V175.574",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5664 172.261V175.574",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2598 172.261V175.574",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8047 172.261V175.574",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M73.041 172.261V175.574",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M51.61 179.451H91.4902V175.905H51.61V179.451Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3789 175.988V179.302",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5352 175.988V179.302",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0781 175.988V179.302",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7715 175.988V179.302",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4688 175.988V179.302",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1621 175.988V179.302",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M76.709 175.988V179.302",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9434 175.988V179.302",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5416 183.179H92.4219V179.632H52.5416V183.179Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3125 179.716V183.029",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4668 179.716V183.029",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0078 179.716V183.029",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7031 179.716V183.029",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4004 179.716V183.029",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0938 179.716V183.029",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6406 179.716V183.029",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M71.877 179.716V183.029",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M52.774 186.906H92.6543V183.36H52.774V186.906Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5449 183.443V186.757",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6992 183.443V186.757",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2422 183.443V186.757",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9355 183.443V186.757",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6328 183.443V186.757",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3262 183.443V186.757",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M77.875 183.443V186.757",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1094 183.443V186.757",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7076 190.635H93.5879V187.089H53.7076V190.635Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4766 187.172V190.485",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6328 187.172V190.485",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1738 187.172V190.485",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8672 187.172V190.485",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5664 187.172V190.485",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2598 187.172V190.485",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8047 187.172V190.485",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M73.041 187.172V190.485",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7076 194.362H93.5879V190.816H53.7076V194.362Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4766 190.9V194.214",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6328 190.9V194.214",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1738 190.9V194.214",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8672 190.9V194.214",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5664 190.9V194.214",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2598 190.9V194.214",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8047 190.9V194.214",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M73.041 190.9V194.214",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M52.774 198.091H92.6543V194.545H52.774V198.091Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5449 194.628V197.941",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6992 194.628V197.941",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2422 194.628V197.941",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9355 194.628V197.941",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6328 194.628V197.941",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3262 194.628V197.941",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M77.875 194.628V197.941",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1094 194.628V197.941",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7076 201.819H93.5879V198.273H53.7076V201.819Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4766 198.356V201.67",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6328 198.356V201.67",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1738 198.356V201.67",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8672 198.356V201.67",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5664 198.356V201.67",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2598 198.356V201.67",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8047 198.356V201.67",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M73.041 198.356V201.67",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M279.824 186.702C276.599 183.113 267.843 180.541 257.54 180.541C247.917 180.541 239.646 182.787 235.969 186.007L233.928 185.975V189.749C233.928 194.833 244.501 198.957 257.54 198.957C270.579 198.957 281.152 194.833 281.152 189.749V186.725L279.824 186.702Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M257.54 195.933C270.581 195.933 281.152 191.81 281.152 186.725C281.152 181.639 270.581 177.517 257.54 177.517C244.499 177.517 233.928 181.639 233.928 186.725C233.928 191.81 244.499 195.933 257.54 195.933Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M257.541 194.6C268.693 194.6 277.733 191.074 277.733 186.725C277.733 182.376 268.693 178.85 257.541 178.85C246.39 178.85 237.35 182.376 237.35 186.725C237.35 191.074 246.39 194.6 257.541 194.6Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M255.868 181.514V180.755H259.232V181.514C262.149 181.747 263.645 182.624 263.645 184.008V184.329H259.754V183.905C259.754 183.178 259.008 182.898 257.699 182.898C256.389 182.898 255.644 183.178 255.644 183.905C255.644 186.007 263.682 186.109 263.682 189.031C263.682 190.429 262.149 191.305 259.232 191.538V192.284H255.868V191.515C252.918 191.282 251.422 190.392 251.422 189.008V188.309H255.308V189.11C255.308 189.842 256.128 190.103 257.438 190.103C258.747 190.103 259.568 189.842 259.568 189.11C259.568 187.013 251.534 186.911 251.534 183.984C251.524 182.661 252.983 181.761 255.868 181.514Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M255.868 180.97V180.215H259.232V180.97C262.149 181.203 263.645 182.079 263.645 183.463V183.784H259.754V183.36C259.754 182.633 259.008 182.358 257.699 182.358C256.389 182.358 255.644 182.633 255.644 183.36C255.644 185.462 263.682 185.565 263.682 188.486C263.682 189.884 262.149 190.76 259.232 190.993V191.734H255.868V190.993C252.918 190.76 251.422 189.87 251.422 188.486V187.787H255.308V188.589C255.308 189.32 256.128 189.581 257.438 189.581C258.747 189.581 259.568 189.32 259.568 188.589C259.568 186.492 251.534 186.389 251.534 183.463C251.524 182.093 252.983 181.221 255.868 180.97Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M235.443 192.997V190.29",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M237.273 194.241V191.753",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M239.25 195.411V192.703",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M241.957 196.581V193.654",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M245.178 195.971V194.68",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M245.178 197.536V197.023",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M249.342 198.412V195.561",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M254.908 196.874V195.849",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M254.908 198.85V198.044",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M304.156 192.861C301.178 188.845 292.608 185.513 282.328 184.795C272.729 184.119 264.327 185.913 260.426 189.054L258.39 188.877L258.143 192.861C257.807 198.234 268.083 203.323 281.093 204.237C294.104 205.15 304.943 201.538 305.265 196.175L305.465 192.983L304.156 192.861Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M305.619 191.958C305.995 186.579 295.727 181.478 282.684 180.565C269.64 179.652 258.761 183.272 258.385 188.651C258.008 194.03 268.277 199.131 281.32 200.044C294.363 200.957 305.242 197.336 305.619 191.958Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.46714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M302.059 192.765C302.388 188.175 293.636 183.807 282.51 183.01C271.384 182.212 262.099 185.287 261.77 189.877C261.441 194.467 270.193 198.834 281.319 199.631C292.444 200.429 301.73 197.355 302.059 192.765Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M280.565 185.705L280.616 184.908L283.972 185.141L283.92 185.943C286.814 186.409 288.249 187.42 288.156 188.883V189.223L284.279 188.948L284.307 188.482C284.354 187.714 283.627 187.369 282.322 187.28C281.017 187.192 280.248 187.429 280.202 188.212C280.062 190.426 288.077 191.097 287.881 194.177C287.793 195.636 286.204 196.47 283.277 196.507L283.231 197.29L279.871 197.057L279.922 196.269C276.991 195.803 275.556 194.773 275.649 193.315L275.695 192.574L279.573 192.844L279.521 193.692C279.475 194.461 280.276 194.797 281.581 194.89C282.886 194.983 283.725 194.759 283.771 193.991C283.911 191.772 275.9 191.106 276.092 188.026C276.185 186.59 277.695 185.766 280.565 185.705Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M280.622 185.131L280.673 184.329L284.028 184.567L283.977 185.368C286.871 185.834 288.306 186.846 288.213 188.309V188.644L284.331 188.374L284.359 187.908C284.41 187.139 283.683 186.794 282.374 186.701C281.064 186.608 280.305 186.85 280.258 187.633C280.118 189.851 288.129 190.522 287.938 193.603C287.845 195.061 286.26 195.895 283.334 195.933L283.283 196.715L279.927 196.482L279.979 195.695C277.048 195.229 275.612 194.199 275.705 192.736L275.752 191.999L279.629 192.27L279.578 193.118C279.527 193.887 280.333 194.222 281.638 194.311C282.942 194.399 283.781 194.185 283.828 193.416C283.968 191.198 275.957 190.527 276.148 187.451C276.218 186.011 277.733 185.191 280.622 185.131Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M259.455 196.399L259.632 193.542",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M261.199 197.839L261.362 195.216",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M263.092 199.214L263.274 196.357",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M265.713 200.639L265.909 197.55",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M268.967 200.22L269.055 198.859",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M268.863 201.87L268.896 201.329",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M272.971 203.09L273.157 200.075",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M278.619 201.856L278.689 200.774",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M278.486 203.944L278.538 203.091",
    stroke: "#263238",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.aceaf3d25c6785f039848ac83e8ad474.svg";
export { ForwardRef as ReactComponent };